export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents a date in the format YYYY-MM-DD. */
  Date: { input: any; output: any; }
  /**
   * Represents signed double-precision fractional values as specified by [IEEE
   * 754](https://en.wikipedia.org/wiki/IEEE_floating_point).
   */
  Double: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** A bulk message */
export type BulkMessage = Node & {
  __typename?: 'BulkMessage';
  /** The users that the bulk message would be delivered to if/when it is sent */
  audienceReach: StudentConnection;
  /** The campaign type of the bulk message */
  campaignType: BulkMessageCampaignTypeEnum;
  /** When the bulk message was created */
  createdAt: Scalars['Double']['output'];
  /** The user that created the bulk message */
  createdBy?: Maybe<User>;
  /** Message is marked as draft */
  draft?: Maybe<Scalars['Boolean']['output']>;
  /** Filters that the bulk message has */
  filters: BulkMessageFilter;
  id: Scalars['ID']['output'];
  messageParts?: Maybe<MessagePartConnection>;
  /** The name of the bulk message */
  name: Scalars['String']['output'];
  /** How is the sender being assigned? */
  senderType: BulkMessageSenderTypeEnum;
  /** The user that sent the bulk message */
  sentFrom?: Maybe<User>;
  /** The users that the bulk message was delivered to */
  sentTo: StudentConnection;
  /** When the bulk message should start being sent */
  startSendingAt?: Maybe<Scalars['Double']['output']>;
  /** When the bulk message should stop being sent */
  stopSendingAt?: Maybe<Scalars['Double']['output']>;
};


/** A bulk message */
export type BulkMessageAudienceReachArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A bulk message */
export type BulkMessageMessagePartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A bulk message */
export type BulkMessageSentToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** How this message is being sent */
export enum BulkMessageCampaignTypeEnum {
  /** Bulk message will be sent over time as a campaign */
  Campaign = 'CAMPAIGN',
  /** Bulk message will be sent once */
  OneTimeSend = 'ONE_TIME_SEND'
}

/** The connection type for BulkMessage. */
export type BulkMessageConnection = {
  __typename?: 'BulkMessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BulkMessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BulkMessage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Returns a list of students and the ids of any missing students */
export type BulkMessageCsvProposal = {
  __typename?: 'BulkMessageCsvProposal';
  /** IDs of users from the csv that were missing from our system */
  missingStudentIds: Array<Scalars['Int']['output']>;
  /** Students matching the ids from the csv */
  students: StudentConnection;
};


/** Returns a list of students and the ids of any missing students */
export type BulkMessageCsvProposalStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type BulkMessageEdge = {
  __typename?: 'BulkMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BulkMessage>;
};

export type BulkMessageFilter = {
  __typename?: 'BulkMessageFilter';
  /** Assigned counselor filters */
  assignedCounselorIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Commit index filters */
  commitIndexes?: Maybe<Array<PredictionIndexEnum>>;
  /** First time message recipient filter */
  firstTimeMessageRecipients?: Maybe<Array<MessagingYesNoEnum>>;
  /** Funnel state filters */
  funnelStates?: Maybe<Array<FunnelStateEnum>>;
  /** Interest filters */
  interestIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Location filters */
  locations?: Maybe<Array<BulkMessageLocationEnum>>;
  /** Major filters */
  majorIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Start terms filter */
  startTerms?: Maybe<Array<BulkMessageStartTerm>>;
  /** Student source filters */
  studentSource?: Maybe<Array<BulkMessageStudentSourceEnum>>;
  /** Student type filters */
  studentTypes?: Maybe<Array<StudentTypeEnum>>;
  /** Target organizations */
  targetOrganizations?: Maybe<Array<Scalars['ID']['output']>>;
  /** User id filters */
  userIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Filters for finding students for bulk message to be sent to */
export type BulkMessageFilterInput = {
  /** Assigned counselor filters */
  assignedCounselorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Commit index filters */
  commitIndexes?: InputMaybe<Array<PredictionIndexEnum>>;
  /** First time message recipient filter (Yes/No */
  firstTimeMessageRecipients?: InputMaybe<Array<MessagingYesNoEnum>>;
  /** Funnel state filters */
  funnelStates?: InputMaybe<Array<FunnelStateEnum>>;
  /** Interest filters */
  interestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Location filters */
  locations?: InputMaybe<Array<BulkMessageLocationEnum>>;
  /** Major filters */
  majorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start terms filter */
  startTerms?: InputMaybe<Array<BulkMessageStartTermInput>>;
  /** Student source filters */
  studentSource?: InputMaybe<Array<BulkMessageStudentSourceEnum>>;
  /** Student type filters */
  studentTypes?: InputMaybe<Array<StudentTypeEnum>>;
  /** User id filters */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Returns a list of students */
export type BulkMessageFilterProposal = {
  __typename?: 'BulkMessageFilterProposal';
  /** Students matching filters */
  students: StudentConnection;
};


/** Returns a list of students */
export type BulkMessageFilterProposalStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Student locations to be targeted by bulk message */
export enum BulkMessageLocationEnum {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** All international students */
  AllInternationalStudents = 'ALL_INTERNATIONAL_STUDENTS',
  /** All US students */
  AllUsStudents = 'ALL_US_STUDENTS',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

/** An order by which a bulk message connection should be ordered */
export type BulkMessageOrderingInput = {
  /** The direction in which to order */
  direction: SortDirectionEnum;
  /** The bulk message field by which to order */
  field: BulkMessageSortableFieldEnum;
};

/** Possible proposal results */
export type BulkMessageProposalUnion = BulkMessageCsvProposal | BulkMessageFilterProposal;

/** Bulk message proposal options */
export type BulkMessageProposeInput =
  /** CSV list of student ids to send bulk message to */
  { csvFile: Scalars['Upload']['input']; filters?: never; }
  |  /** Filters used for finding students to send bulk message to */
  { csvFile?: never; filters: BulkMessageFilterInput; };

export type BulkMessageSendLaterInput = {
  startSendingAt: Scalars['Double']['input'];
};

export type BulkMessageSendOptionInput =
  { sendLater: BulkMessageSendLaterInput; sendNow?: never; startCampaign?: never; }
  |  { sendLater?: never; sendNow: UnitEnum; startCampaign?: never; }
  |  { sendLater?: never; sendNow?: never; startCampaign: BulkMessageStartCampaignInput; };

/** Possible send status values */
export enum BulkMessageSendStatusEnum {
  /** Bulk message campaigns that are currently sending */
  Active = 'ACTIVE',
  /** Bulk messages that are drafts */
  Draft = 'DRAFT',
  /** Bulk messages that will start sending at some point in the future */
  Scheduled = 'SCHEDULED',
  /** Bulk messages that have been sent */
  Sent = 'SENT'
}

export type BulkMessageSenderInput =
  { assignedCounselor: UnitEnum; userId?: never; }
  |  { assignedCounselor?: never; userId: Scalars['ID']['input']; };

/** Possible sender type values */
export enum BulkMessageSenderTypeEnum {
  /** Bulk message will be sent to the assigned counselor of each student */
  AssignedCounselor = 'ASSIGNED_COUNSELOR',
  /** All bulk messages will be sent to the user represented by sentFrom */
  UserId = 'USER_ID'
}

/** Filter by who is sending the message */
export type BulkMessageSentFromFilterInput = {
  /** Bulk messages with these kind of senders */
  senderType: BulkMessageSenderTypeEnum;
  /** Bulk message is sent from these specific users */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The fields by which bulk messages may be sorted */
export enum BulkMessageSortableFieldEnum {
  /** Sort by campaign type */
  CampaignType = 'CAMPAIGN_TYPE',
  /** Sort by the name of the user that created the message */
  CreatedBy = 'CREATED_BY',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by the name of the counselor assigned to send the message */
  SentFrom = 'SENT_FROM',
  /** Sort by start_sending_at/created_at */
  StartSendingAt = 'START_SENDING_AT',
  /** Sort by stop_sending_at/created_at */
  StopSendingAt = 'STOP_SENDING_AT'
}

export type BulkMessageStartCampaignInput = {
  startSendingAt: Scalars['Double']['input'];
  stopSendingAt: Scalars['Double']['input'];
};

/** Gives the students who start in this term */
export type BulkMessageStartTerm = {
  __typename?: 'BulkMessageStartTerm';
  /** Which semester for the start term */
  semester?: Maybe<EntryTermEnum>;
  /** Which year for the start term */
  year?: Maybe<Scalars['Int']['output']>;
};

/** Used to select start term filter */
export type BulkMessageStartTermInput = {
  /** Which semester for the start term */
  semester: EntryTermEnum;
  /** Which year for the start term */
  year: Scalars['Int']['input'];
};

/** How the students joined the community */
export enum BulkMessageStudentSourceEnum {
  /** Community Match */
  CommunityMatch = 'COMMUNITY_MATCH',
  /** Competitor Match */
  CompetitorMatch = 'COMPETITOR_MATCH'
}

/**
 * All NOT_DONE student statuses for the rise user action will be updated to this
 * status. Actions marked as DONE or SKIPPED will not change.
 */
export type BulkUpdateRiseUserActionStudentStatusAllInput = {
  riseUserActionId: Scalars['ID']['input'];
  status: RiseUserActionStudentStatusEnum;
};

/** Thse student statuses matching the given ids for the rise user action will be updated to this status */
export type BulkUpdateRiseUserActionStudentStatusIdsInput = {
  riseUserActionId: Scalars['ID']['input'];
  riseUserActionStudentStatusIds: Array<Scalars['ID']['input']>;
  status: RiseUserActionStudentStatusEnum;
};

export type BulkUpdateRiseUserActionStudentStatusInput =
  /** Update all statuses for this rise user action */
  { updateAll: BulkUpdateRiseUserActionStudentStatusAllInput; updateIds?: never; }
  |  /** Update only the statuses for these ids */
  { updateAll?: never; updateIds: BulkUpdateRiseUserActionStudentStatusIdsInput; };

/** Autogenerated input type of BulkUpdateRiseUserActionStudentStatusMutation */
export type BulkUpdateRiseUserActionStudentStatusMutationInput = {
  argument: BulkUpdateRiseUserActionStudentStatusInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUpdateRiseUserActionStudentStatusMutation. */
export type BulkUpdateRiseUserActionStudentStatusMutationPayload = {
  __typename?: 'BulkUpdateRiseUserActionStudentStatusMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

export type ChatBaseUserInterface = {
  /** @deprecated Does not work for all user names */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Does not work for all user names */
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Image>;
  uuid: Scalars['String']['output'];
};

/** An Ejabberd multi-user chat room */
export type ChatChannel = Node & {
  __typename?: 'ChatChannel';
  /** Channel display name */
  displayName: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
  /** Channel name */
  roomName: Scalars['String']['output'];
};

/** The connection type for ChatChannel. */
export type ChatChannelConnection = {
  __typename?: 'ChatChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChatChannelEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChatChannel>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChatChannelEdge = {
  __typename?: 'ChatChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChatChannel>;
};

/** An order by which a chat channel connection should be ordered */
export type ChatChannelOrderingInput = {
  direction: SortDirectionEnum;
  field: ChatChannelSortableFieldEnum;
};

/** Fields by which chat channels can be ordered */
export enum ChatChannelSortableFieldEnum {
  /** Order by channel display name */
  DisplayName = 'DISPLAY_NAME'
}

export type ChatGamesBot = ChatBaseUserInterface & Node & {
  __typename?: 'ChatGamesBot';
  /** @deprecated Does not work for all user names */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Does not work for all user names */
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Image>;
  uuid: Scalars['String']['output'];
};

/** Country classification */
export enum CountryClassificationEnum {
  /** All US locations (including territories) */
  Domestic = 'DOMESTIC',
  /** All non-US locations */
  International = 'INTERNATIONAL'
}

/** Autogenerated input type of CreateBannedFromOrgMutation */
export type CreateBannedFromOrgMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Relay ID of organization */
  organizationId: Scalars['ID']['input'];
  /** Relay ID of user to ban */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBannedFromOrgMutation. */
export type CreateBannedFromOrgMutationPayload = {
  __typename?: 'CreateBannedFromOrgMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of CreateBulkMessageMutation */
export type CreateBulkMessageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdById: Scalars['ID']['input'];
  draft: Scalars['Boolean']['input'];
  filters: BulkMessageFilterInput;
  messageParts?: InputMaybe<Array<MessagePartInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sendOption?: InputMaybe<BulkMessageSendOptionInput>;
  sender?: InputMaybe<BulkMessageSenderInput>;
};

/** Autogenerated return type of CreateBulkMessageMutation. */
export type CreateBulkMessageMutationPayload = {
  __typename?: 'CreateBulkMessageMutationPayload';
  bulkMessage?: Maybe<BulkMessage>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of CreateDashInviteMutation */
export type CreateDashInviteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  role: DashInviteRoleEnum;
};

/** Autogenerated return type of CreateDashInviteMutation. */
export type CreateDashInviteMutationPayload = {
  __typename?: 'CreateDashInviteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  messages?: Maybe<Array<InformationalMessage>>;
};

/** Autogenerated input type of CreateDataManagementFileMutation */
export type CreateDataManagementFileMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data management file */
  file: Scalars['Upload']['input'];
  /** ID of organization */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateDataManagementFileMutation. */
export type CreateDataManagementFileMutationPayload = {
  __typename?: 'CreateDataManagementFileMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dataManagementFile?: Maybe<DataManagementFile>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of CreateFeedPostMutation */
export type CreateFeedPostMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input data for creating a feed post */
  input: CreateFeedPostOneOfInput;
};

/** Autogenerated return type of CreateFeedPostMutation. */
export type CreateFeedPostMutationPayload = {
  __typename?: 'CreateFeedPostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  feedPost?: Maybe<FeedPost>;
};

/** Input for creating feed posts. */
export type CreateFeedPostOneOfInput =
  /** Create photo feed post */
  { photo: CreateFeedPostPhotoInput; video?: never; }
  |  /** Create video feed post */
  { photo?: never; video: CreateFeedPostVideoInput; };

/** Input for creating photo feed posts */
export type CreateFeedPostPhotoInput = {
  /** Optional caption */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** CTA button label */
  ctaText?: InputMaybe<Scalars['String']['input']>;
  /** CTA button URL */
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** If true, save as draft */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, JSON as string from FilePicker */
  filepickerBlob: Scalars['String']['input'];
  /** Height of the uploaded image */
  imageHeight: Scalars['Int']['input'];
  /** Width of the uploaded image */
  imageWidth: Scalars['Int']['input'];
  /** Internal name of the post */
  name: Scalars['String']['input'];
  /** Org official to post as */
  postedByOfficialId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional date to publish post at. Format: seconds-since-epoch/unix-time UTC.
   * Example: 2020-02-14 07:16:55 UTC would be 1581693415
   */
  publishAt?: InputMaybe<Scalars['Double']['input']>;
};

/** Input for creating video feed posts */
export type CreateFeedPostVideoInput = {
  /** Optional caption */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** CTA button label */
  ctaText?: InputMaybe<Scalars['String']['input']>;
  /** CTA button URL */
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** If true, save as draft */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, JSON as string from FilePicker */
  filepickerBlob: Scalars['String']['input'];
  /** Internal name of the post */
  name: Scalars['String']['input'];
  /** Org official to post as */
  postedByOfficialId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional date to publish post at. Format: seconds-since-epoch/unix-time UTC.
   * Example: 2020-02-14 07:16:55 UTC would be 1581693415
   */
  publishAt?: InputMaybe<Scalars['Double']['input']>;
};

/** Attributes for reporting a chat message */
export type CreateReportedContentChatMessageInput = {
  /** ID of the chat message being reported */
  chatMessageId: Scalars['String']['input'];
  /** Optional screenshot or image upload */
  image: Scalars['Upload']['input'];
  /** Why this profile is being reported */
  reason: ReportedContentReasonEnum;
  /** ID of user that is being reported */
  reportedUserId: Scalars['ID']['input'];
};

export type CreateReportedContentInput =
  /** Report a chat message */
  { chatMessage: CreateReportedContentChatMessageInput; studentProfile?: never; }
  |  /** Report a student profile */
  { chatMessage?: never; studentProfile: CreateReportedContentStudentProfileInput; };

/** Autogenerated input type of CreateReportedContentMutation */
export type CreateReportedContentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: CreateReportedContentInput;
};

/** Autogenerated return type of CreateReportedContentMutation. */
export type CreateReportedContentMutationPayload = {
  __typename?: 'CreateReportedContentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Attributes for reporting a student profile */
export type CreateReportedContentStudentProfileInput = {
  /** Optional screenshot or image upload */
  image: Scalars['Upload']['input'];
  /** Why this profile is being reported */
  reason: ReportedContentReasonEnum;
  /** ID of user that is being reported */
  reportedUserId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateRiseUserActionGoalMutation */
export type CreateRiseUserActionGoalMutationInput = {
  capacity: RiseUserActionCapacityEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRiseUserActionGoalMutation. */
export type CreateRiseUserActionGoalMutationPayload = {
  __typename?: 'CreateRiseUserActionGoalMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  riseUserActionGoal?: Maybe<RiseUserActionGoal>;
};

/** Autogenerated input type of CreateUserProfileAnswerMutation */
export type CreateUserProfileAnswerMutationInput = {
  answer: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  profileQuestionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUserProfileAnswerMutation. */
export type CreateUserProfileAnswerMutationPayload = {
  __typename?: 'CreateUserProfileAnswerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  profileAnswer?: Maybe<ProfileAnswer>;
};

/** A user invited object */
export type DashInvite = Node & {
  __typename?: 'DashInvite';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedAt: Scalars['Double']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  /** What role will this user have? */
  role: DashInviteRoleEnum;
};

/** The connection type for DashInvite. */
export type DashInviteConnection = {
  __typename?: 'DashInviteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DashInviteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DashInvite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DashInviteEdge = {
  __typename?: 'DashInviteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DashInvite>;
};

/** An order by which an invitation connection should be ordered */
export type DashInviteOrderingInput = {
  /** The direction in which to order */
  direction: SortDirectionEnum;
  /** The field by which to order */
  field: DashInviteSortableFieldEnum;
};

/** Possible user roles */
export enum DashInviteRoleEnum {
  /** Counselor */
  Counselor = 'COUNSELOR',
  /** Influencer */
  Influencer = 'INFLUENCER'
}

/** The fields by which users may be sorted */
export enum DashInviteSortableFieldEnum {
  /** Sort by when user was invited */
  InvitedAt = 'INVITED_AT',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by role */
  Role = 'ROLE'
}

export type DataManagementFile = Node & {
  __typename?: 'DataManagementFile';
  /** When file was created at */
  createdAt?: Maybe<Scalars['Double']['output']>;
  id: Scalars['ID']['output'];
  /** Name of file */
  name?: Maybe<Scalars['String']['output']>;
  /** Url of file */
  url?: Maybe<Scalars['String']['output']>;
};

/** The connection type for DataManagementFile. */
export type DataManagementFileConnection = {
  __typename?: 'DataManagementFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DataManagementFileEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DataManagementFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DataManagementFileEdge = {
  __typename?: 'DataManagementFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DataManagementFile>;
};

/** Ordering options for data management files */
export type DataManagementFileOrderingInput = {
  direction: SortDirectionEnum;
  field: DataManagementFileSortableFieldEnum;
};

export enum DataManagementFileSortableFieldEnum {
  /** Created at */
  CreatedAt = 'CREATED_AT'
}

/** Represents a date range with start and inclusive end dates in YYYY-MM-DD format */
export type DateRangeInput = {
  /** The inclusive ending date of the range (format: YYYY-MM-DD) */
  inclusiveEnd: Scalars['Date']['input'];
  /** The starting date of the range (format: YYYY-MM-DD) */
  start: Scalars['Date']['input'];
};

/** Autogenerated input type of DestroyBulkMessageMutation */
export type DestroyBulkMessageMutationInput = {
  bulkMessageId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyBulkMessageMutation. */
export type DestroyBulkMessageMutationPayload = {
  __typename?: 'DestroyBulkMessageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecoverableError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DestroyDashInviteMutation */
export type DestroyDashInviteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Relay ID of invitation to delete */
  dashInviteId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyDashInviteMutation. */
export type DestroyDashInviteMutationPayload = {
  __typename?: 'DestroyDashInviteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of DestroyFeedPostMutation */
export type DestroyFeedPostMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedPostId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyFeedPostMutation. */
export type DestroyFeedPostMutationPayload = {
  __typename?: 'DestroyFeedPostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecoverableError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DestroyLiveEventMutation */
export type DestroyLiveEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  liveEventId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyLiveEventMutation. */
export type DestroyLiveEventMutationPayload = {
  __typename?: 'DestroyLiveEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecoverableError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DestroyProfileAnswerMutation */
export type DestroyProfileAnswerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  profileAnswerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyProfileAnswerMutation. */
export type DestroyProfileAnswerMutationPayload = {
  __typename?: 'DestroyProfileAnswerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecoverableError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Engagement percentile options */
export enum EngagementPercentileEnum {
  /** Top-1-Percent */
  Top_1Percent = 'TOP_1_PERCENT',
  /** Top-5-Percent */
  Top_5Percent = 'TOP_5_PERCENT',
  /** Top-10-Percent */
  Top_10Percent = 'TOP_10_PERCENT',
  /** Top-25-Percent */
  Top_25Percent = 'TOP_25_PERCENT',
  /** Top-50-Percent */
  Top_50Percent = 'TOP_50_PERCENT'
}

/** Entry term options */
export enum EntryTermEnum {
  /** Fall */
  Fall = 'FALL',
  /** Spring */
  Spring = 'SPRING',
  /** Summer */
  Summer = 'SUMMER'
}

/** Types of FAFSA statuses */
export enum FafsaCompletionStatusEnum {
  /** No */
  No = 'NO',
  /** Non-filer */
  NonFiler = 'NON_FILER',
  /** Yes */
  Yes = 'YES'
}

/** A student and why they are spotlighted */
export type FeaturedStudentSpotlight = {
  __typename?: 'FeaturedStudentSpotlight';
  /** Why this student is spotlighted */
  reason?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
};

/** A feed post object */
export type FeedPost = Node & {
  __typename?: 'FeedPost';
  caption?: Maybe<Scalars['String']['output']>;
  ctaStudent?: Maybe<Student>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  postedBy: User;
  publishDate: Scalars['Double']['output'];
  video?: Maybe<Video>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for FeedPost. */
export type FeedPostConnection = {
  __typename?: 'FeedPostConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FeedPostEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FeedPost>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FeedPostEdge = {
  __typename?: 'FeedPostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FeedPost>;
};

/** An order by which a feed posts connection should be ordered */
export type FeedPostOrderingInput = {
  /** The direction in which to order */
  direction: SortDirectionEnum;
  /** The field by which to order */
  field: FeedPostSortableFieldEnum;
};

/** The fields by which feed posts may be sorted */
export enum FeedPostSortableFieldEnum {
  /** Sort by created at */
  CreatedAt = 'CREATED_AT',
  /** Sort by publish date */
  PublishDate = 'PUBLISH_DATE'
}

/** Whether a feed post is scheduled or currently active */
export enum FeedPostStatusEnum {
  /** Post date is in the past (currently live) */
  Active = 'ACTIVE',
  /** Post date is in the future (upcoming) */
  Scheduled = 'SCHEDULED'
}

export type FileStackPolicy = {
  __typename?: 'FileStackPolicy';
  container: Scalars['String']['output'];
  maxSize?: Maybe<Scalars['Int']['output']>;
  path: Scalars['String']['output'];
  policy: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

export enum FileStackPolicyKindEnum {
  PhotoConvert = 'PHOTO_CONVERT',
  PhotoUpload = 'PHOTO_UPLOAD',
  VideoUpload = 'VIDEO_UPLOAD'
}

/** Funnel chart data */
export type FunnelChartData = {
  __typename?: 'FunnelChartData';
  inCommunity: Array<FunnelStateDataPoint>;
  notInCommunity: Array<FunnelStateDataPoint>;
};

/** Number of students with the given funnel state */
export type FunnelStateDataPoint = {
  __typename?: 'FunnelStateDataPoint';
  /** A particular funnel state */
  state: FunnelStateEnum;
  /** A count of students */
  value: Scalars['Int']['output'];
};

/** The funnel state values */
export enum FunnelStateEnum {
  /** Acceptance Declined */
  AcceptanceDeclined = 'ACCEPTANCE_DECLINED',
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Application Canceled */
  ApplicationCanceled = 'APPLICATION_CANCELED',
  /** Application Complete */
  ApplicationComplete = 'APPLICATION_COMPLETE',
  /** Application Complete Withdrawn */
  ApplicationCompleteWithdrawn = 'APPLICATION_COMPLETE_WITHDRAWN',
  /** Application Started */
  ApplicationStarted = 'APPLICATION_STARTED',
  /** Application Started Canceled */
  ApplicationStartedCanceled = 'APPLICATION_STARTED_CANCELED',
  /** Applied */
  Applied = 'APPLIED',
  /** Commitment Withdrawn */
  CommitmentWithdrawn = 'COMMITMENT_WITHDRAWN',
  /** Committed */
  Committed = 'COMMITTED',
  /** Deferred */
  Deferred = 'DEFERRED',
  /** Deferred Withdrawn */
  DeferredWithdrawn = 'DEFERRED_WITHDRAWN',
  /** Denied */
  Denied = 'DENIED',
  /** Enrolled */
  Enrolled = 'ENROLLED',
  /** Inquired */
  Inquired = 'INQUIRED',
  /** Inquired dropped */
  InquiredDropped = 'INQUIRED_DROPPED',
  /** Lead */
  Lead = 'LEAD',
  /** Lead dropped */
  LeadDropped = 'LEAD_DROPPED',
  /** Waitlisted */
  Waitlisted = 'WAITLISTED',
  /** Waitlisted Withdrawn */
  WaitlistedWithdrawn = 'WAITLISTED_WITHDRAWN'
}

/** When a user transitioned to a given funnel state */
export type FunnelStateTransitionDate = {
  __typename?: 'FunnelStateTransitionDate';
  /** Date of transition */
  date: Scalars['Date']['output'];
  /** A particular funnel state */
  state: FunnelStateEnum;
};

/** Gender options */
export enum GenderEnum {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE',
  /** Other */
  Other = 'OTHER'
}

/** The going statusus for a student */
export enum GoingStatusEnum {
  /** Going */
  Going = 'GOING',
  /** Not going */
  Notgoing = 'NOTGOING',
  /** Undecided */
  Undecided = 'UNDECIDED'
}

export type IceBreaker = Node & {
  __typename?: 'IceBreaker';
  /** Heading to display above ice breaker */
  heading?: Maybe<Scalars['String']['output']>;
  /** Custom heading background color */
  headingBgColor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
};

export type IceBreakerGroup = Node & {
  __typename?: 'IceBreakerGroup';
  /** Group name decorator */
  decorator?: Maybe<Scalars['String']['output']>;
  /** Ice breakers in group */
  iceBreakers: Array<Maybe<IceBreaker>>;
  id: Scalars['ID']['output'];
  /** Group name */
  name: Scalars['String']['output'];
};

export type Image = Node & {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Uncropped photo URL */
  uncroppedUrl?: Maybe<Scalars['String']['output']>;
  /** Square aspect ratio photo URL */
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type ImageUncroppedUrlArgs = {
  width: Scalars['Int']['input'];
};


export type ImageUrlArgs = {
  size: Scalars['Int']['input'];
};

export type InformationalMessage = {
  __typename?: 'InformationalMessage';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InsightBot = ChatBaseUserInterface & Node & {
  __typename?: 'InsightBot';
  /** @deprecated Does not work for all user names */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Does not work for all user names */
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Image>;
  uuid: Scalars['String']['output'];
};

/** An interest that users can have, such as Woodworking. */
export type Interest = Node & {
  __typename?: 'Interest';
  id: Scalars['ID']['output'];
  /** The name of the interest. */
  name: Scalars['String']['output'];
};

/** The connection type for Interest. */
export type InterestConnection = {
  __typename?: 'InterestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InterestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Interest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterestEdge = {
  __typename?: 'InterestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Interest>;
};

/** Join states */
export enum JoinStateEnum {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Admitted */
  Admitted = 'ADMITTED',
  /** Applied */
  Applied = 'APPLIED',
  /** App complete */
  AppComplete = 'APP_COMPLETE',
  /** Committed */
  Committed = 'COMMITTED',
  /** Date of initial contact missing */
  DateOfInitialContactMissing = 'DATE_OF_INITIAL_CONTACT_MISSING',
  /** Inquired */
  Inquired = 'INQUIRED',
  /** For a nil join state */
  Null = 'NULL',
  /** Pre-Inquired */
  PreInquired = 'PRE_INQUIRED'
}

/** How a student joined a community */
export enum JoinTypeEnum {
  /** Joined by branch link */
  Branch = 'BRANCH',
  /** Joined by competitor match */
  CompetitorMatch = 'COMPETITOR_MATCH',
  /** Joined by CSV */
  Csv = 'CSV',
  /** Joined organically */
  Organic = 'ORGANIC'
}

/** A live event */
export type LiveEvent = Node & {
  __typename?: 'LiveEvent';
  audience: LiveEventAudienceEnum;
  chatChannel: ChatChannel;
  createdBy?: Maybe<User>;
  endsAt: Scalars['Double']['output'];
  eventType: LiveEventTypeEnum;
  gameType?: Maybe<Scalars['String']['output']>;
  gameVariation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  participantsByFunnelState?: Maybe<Array<FunnelStateDataPoint>>;
  startsAt: Scalars['Double']['output'];
  statistics?: Maybe<LiveEventStatistics>;
};


/** A live event */
export type LiveEventParticipantsByFunnelStateArgs = {
  filters?: InputMaybe<StudentListFilterInput>;
};


/** A live event */
export type LiveEventStatisticsArgs = {
  filters?: InputMaybe<StudentListFilterInput>;
};

/** What type of live event */
export enum LiveEventAudienceEnum {
  /** Admitted students */
  Admits = 'ADMITS',
  /** Applied students */
  Applicants = 'APPLICANTS',
  /** Committed students */
  Commits = 'COMMITS',
  /** Everyone */
  Everyone = 'EVERYONE',
  /** Other */
  Other = 'OTHER'
}

/** The connection type for LiveEvent. */
export type LiveEventConnection = {
  __typename?: 'LiveEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LiveEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LiveEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LiveEventEdge = {
  __typename?: 'LiveEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LiveEvent>;
};

/** An order by which a live events connection should be ordered */
export type LiveEventOrderingInput = {
  /** The direction in which to order */
  direction: SortDirectionEnum;
  /** The field by which to order */
  field: LiveEventSortableFieldEnum;
};

/** The fields by which live events may be sorted */
export enum LiveEventSortableFieldEnum {
  /** Sort by audience */
  Audience = 'AUDIENCE',
  /** Sort by event type */
  EventType = 'EVENT_TYPE',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by start_time */
  StartTime = 'START_TIME'
}

/** Statistics related to a live event */
export type LiveEventStatistics = {
  __typename?: 'LiveEventStatistics';
  /** Total number of students who sent a message during the live event */
  studentsWhoMessaged?: Maybe<Scalars['Int']['output']>;
  /** Total number of channel opens during the event */
  totalChannelOpens?: Maybe<Scalars['Int']['output']>;
  /** Total number of messages sent during the event */
  totalMessages?: Maybe<Scalars['Int']['output']>;
  /** Total number of students who participated in the event */
  totalParticipants?: Maybe<Scalars['Int']['output']>;
};

export enum LiveEventStatusEnum {
  /** Live event has finished */
  Completed = 'COMPLETED',
  /** Live event has not started/is active */
  Scheduled = 'SCHEDULED'
}

/** What type of live event */
export enum LiveEventTypeEnum {
  /** An automated bot event */
  BotEvent = 'BOT_EVENT',
  /** A virtual event */
  LiveEvent = 'LIVE_EVENT'
}

/** City */
export type LocationCity = Node & {
  __typename?: 'LocationCity';
  displayString: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** The connection type for LocationCity. */
export type LocationCityConnection = {
  __typename?: 'LocationCityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationCityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LocationCity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationCityEdge = {
  __typename?: 'LocationCityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LocationCity>;
};

/** Represents a major of interest for users. */
export type Major = Node & {
  __typename?: 'Major';
  id: Scalars['ID']['output'];
  /** The name of the major. */
  name: Scalars['String']['output'];
};

/** The connection type for Major. */
export type MajorConnection = {
  __typename?: 'MajorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MajorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Major>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MajorEdge = {
  __typename?: 'MajorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Major>;
};

/** A chat message sent as part of a bulk message */
export type MessagePart = Node & {
  __typename?: 'MessagePart';
  /** Body of the message */
  body: MessagePartBodyUnion;
  id: Scalars['ID']['output'];
};

/** A message part that has an attachment */
export type MessagePartAttachment = {
  __typename?: 'MessagePartAttachment';
  /** What kind of attachment this is */
  type: MessagePartAttachmentEnum;
  /** Attachment's url */
  url: Scalars['String']['output'];
};

/** What type of attachment does this message part have */
export enum MessagePartAttachmentEnum {
  /** Image */
  Image = 'IMAGE',
  /** Video */
  Video = 'VIDEO'
}

/** What the multipart message body can be */
export type MessagePartBodyInput =
  /** Image or video to be sent as image body */
  { attachment: Scalars['Upload']['input']; text?: never; }
  |  /** The body for a text message */
  { attachment?: never; text: Scalars['String']['input']; };

/** Possible options for the body of a message */
export type MessagePartBodyUnion = MessagePartAttachment | MessagePartText;

/** The connection type for MessagePart. */
export type MessagePartConnection = {
  __typename?: 'MessagePartConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessagePartEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MessagePart>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A chat message sent as part of a bulk message */
export type MessagePartCreateInput = {
  /** The body of the message */
  body: MessagePartBodyInput;
};

/** An edge in a connection. */
export type MessagePartEdge = {
  __typename?: 'MessagePartEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MessagePart>;
};

/** A chat message sent as part of a bulk message */
export type MessagePartInput =
  { create: MessagePartCreateInput; update?: never; }
  |  { create?: never; update: MessagePartUpdateInput; };

/** A message part body that is just text */
export type MessagePartText = {
  __typename?: 'MessagePartText';
  /** The message text */
  text: Scalars['String']['output'];
};

/** An update of an existing message part */
export type MessagePartUpdateInput = {
  /** The body of the message */
  body?: InputMaybe<MessagePartBodyInput>;
  /** ID of the message part */
  messagePartId: Scalars['ID']['input'];
};

/** Yes or No */
export enum MessagingYesNoEnum {
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

export type Mutation = {
  __typename?: 'Mutation';
  bulkUpdateRiseUserActionStudentStatusMutation?: Maybe<BulkUpdateRiseUserActionStudentStatusMutationPayload>;
  createBannedFromOrg?: Maybe<CreateBannedFromOrgMutationPayload>;
  /** Create bulk message */
  createBulkMessageMutation?: Maybe<CreateBulkMessageMutationPayload>;
  /** Create invitation */
  createDashInviteMutation?: Maybe<CreateDashInviteMutationPayload>;
  createDataManagementFileMutation?: Maybe<CreateDataManagementFileMutationPayload>;
  createFeedPostMutation?: Maybe<CreateFeedPostMutationPayload>;
  createReportedContentMutation?: Maybe<CreateReportedContentMutationPayload>;
  createRiseUserActionGoalMutation?: Maybe<CreateRiseUserActionGoalMutationPayload>;
  createUserProfileAnswerMutation?: Maybe<CreateUserProfileAnswerMutationPayload>;
  /** Delete bulk message */
  destroyBulkMessageMutation?: Maybe<DestroyBulkMessageMutationPayload>;
  destroyDashInviteMutation?: Maybe<DestroyDashInviteMutationPayload>;
  /** Delete feed post */
  destroyFeedPostMutation?: Maybe<DestroyFeedPostMutationPayload>;
  /** Delete live event */
  destroyLiveEventMutation?: Maybe<DestroyLiveEventMutationPayload>;
  /** Delete profile answer */
  destroyProfileAnswerMutation?: Maybe<DestroyProfileAnswerMutationPayload>;
  removeOfficialFromOrganizationMutation?: Maybe<RemoveOfficialFromOrganizationMutationPayload>;
  /** Replace all social media handles for the given user */
  replaceUserSocialsMutation?: Maybe<ReplaceUserSocialsMutationPayload>;
  resendDashInviteMutation?: Maybe<ResendDashInviteMutationPayload>;
  /** Stop a running bulk message campaign */
  stopBulkMessageMutation?: Maybe<StopBulkMessageMutationPayload>;
  /** Update bulk message */
  updateBulkMessageMutation?: Maybe<UpdateBulkMessageMutationPayload>;
  updateFeedPostMutation?: Maybe<UpdateFeedPostMutationPayload>;
  /** Update user contact info */
  updateUserContactInfoMutation?: Maybe<UpdateUserContactInfoMutationPayload>;
  /** Update user notification settings */
  updateUserNotificationSettingsMutation?: Maybe<UpdateUserNotificationSettingsMutationPayload>;
  updateUserProfileAnswerMutation?: Maybe<UpdateUserProfileAnswerMutationPayload>;
  /** Update user profile */
  updateUserProfileMutation?: Maybe<UpdateUserProfileMutationPayload>;
};


export type MutationBulkUpdateRiseUserActionStudentStatusMutationArgs = {
  input: BulkUpdateRiseUserActionStudentStatusMutationInput;
};


export type MutationCreateBannedFromOrgArgs = {
  input: CreateBannedFromOrgMutationInput;
};


export type MutationCreateBulkMessageMutationArgs = {
  input: CreateBulkMessageMutationInput;
};


export type MutationCreateDashInviteMutationArgs = {
  input: CreateDashInviteMutationInput;
};


export type MutationCreateDataManagementFileMutationArgs = {
  input: CreateDataManagementFileMutationInput;
};


export type MutationCreateFeedPostMutationArgs = {
  input: CreateFeedPostMutationInput;
};


export type MutationCreateReportedContentMutationArgs = {
  input: CreateReportedContentMutationInput;
};


export type MutationCreateRiseUserActionGoalMutationArgs = {
  input: CreateRiseUserActionGoalMutationInput;
};


export type MutationCreateUserProfileAnswerMutationArgs = {
  input: CreateUserProfileAnswerMutationInput;
};


export type MutationDestroyBulkMessageMutationArgs = {
  input: DestroyBulkMessageMutationInput;
};


export type MutationDestroyDashInviteMutationArgs = {
  input: DestroyDashInviteMutationInput;
};


export type MutationDestroyFeedPostMutationArgs = {
  input: DestroyFeedPostMutationInput;
};


export type MutationDestroyLiveEventMutationArgs = {
  input: DestroyLiveEventMutationInput;
};


export type MutationDestroyProfileAnswerMutationArgs = {
  input: DestroyProfileAnswerMutationInput;
};


export type MutationRemoveOfficialFromOrganizationMutationArgs = {
  input: RemoveOfficialFromOrganizationMutationInput;
};


export type MutationReplaceUserSocialsMutationArgs = {
  input: ReplaceUserSocialsMutationInput;
};


export type MutationResendDashInviteMutationArgs = {
  input: ResendDashInviteMutationInput;
};


export type MutationStopBulkMessageMutationArgs = {
  input: StopBulkMessageMutationInput;
};


export type MutationUpdateBulkMessageMutationArgs = {
  input: UpdateBulkMessageMutationInput;
};


export type MutationUpdateFeedPostMutationArgs = {
  input: UpdateFeedPostMutationInput;
};


export type MutationUpdateUserContactInfoMutationArgs = {
  input: UpdateUserContactInfoMutationInput;
};


export type MutationUpdateUserNotificationSettingsMutationArgs = {
  input: UpdateUserNotificationSettingsMutationInput;
};


export type MutationUpdateUserProfileAnswerMutationArgs = {
  input: UpdateUserProfileAnswerMutationInput;
};


export type MutationUpdateUserProfileMutationArgs = {
  input: UpdateUserProfileMutationInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** An organization, such as a college */
export type Organization = Node & {
  __typename?: 'Organization';
  /** Get a list of users that match proposed bulk message */
  bulkMessageProposal: BulkMessageProposalUnion;
  /** Bulk messages associated with this organization */
  bulkMessages: BulkMessageConnection;
  chatChannels?: Maybe<ChatChannelConnection>;
  /** Count of students grouped by funnel state */
  commitIndexSummary: PredictionIndexSummary;
  /** Get a list of invitations in this organization */
  dashInvites: DashInviteConnection;
  dataManagementFiles?: Maybe<DataManagementFileConnection>;
  featuredStudentSpotlight?: Maybe<Array<FeaturedStudentSpotlight>>;
  /** Feed posts for this organization */
  feedPosts: FeedPostConnection;
  funnelChartData?: Maybe<FunnelChartData>;
  id: Scalars['ID']['output'];
  /** Live events associated with this organization */
  liveEvents: LiveEventConnection;
  /** The organization logo */
  logo?: Maybe<Image>;
  /** Contextual list of metrics about an organization */
  metrics?: Maybe<Array<OrganizationMetric>>;
  name: Scalars['String']['output'];
  permissions: OrganizationPermission;
  /** RISE data specific to an organization */
  rise?: Maybe<RiseOrganization>;
  /** Number of seats organization has available */
  seatsAvailable: Scalars['Int']['output'];
  /** Is sso enabled? */
  ssoEnabled: Scalars['Boolean']['output'];
  /** List of students in the organization */
  studentList: StudentConnection;
  studentListTimeSeries?: Maybe<Array<TimeSeriesDataPoint>>;
  /** List of org associated (branded) surprise objects */
  surprises?: Maybe<SurpriseConnection>;
  timeZone: Scalars['String']['output'];
  /** Get a list of users in this organization */
  users: UserConnection;
  uuid: Scalars['String']['output'];
};


/** An organization, such as a college */
export type OrganizationBulkMessageProposalArgs = {
  bulkMessageId?: InputMaybe<Scalars['ID']['input']>;
  proposal: BulkMessageProposeInput;
};


/** An organization, such as a college */
export type OrganizationBulkMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  campaignType?: InputMaybe<Array<BulkMessageCampaignTypeEnum>>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<BulkMessageOrderingInput>>;
  sendStatus: Array<BulkMessageSendStatusEnum>;
  sentFrom?: InputMaybe<Array<BulkMessageSentFromFilterInput>>;
};


/** An organization, such as a college */
export type OrganizationChatChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenUsedForLiveEvent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<ChatChannelOrderingInput>>;
};


/** An organization, such as a college */
export type OrganizationCommitIndexSummaryArgs = {
  cohortYear: Scalars['Int']['input'];
};


/** An organization, such as a college */
export type OrganizationDashInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<DashInviteOrderingInput>>;
  roles?: InputMaybe<Array<DashInviteRoleEnum>>;
};


/** An organization, such as a college */
export type OrganizationDataManagementFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<DataManagementFileOrderingInput>>;
};


/** An organization, such as a college */
export type OrganizationFeedPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ctaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<FeedPostOrderingInput>>;
  postedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<FeedPostStatusEnum>>;
};


/** An organization, such as a college */
export type OrganizationFunnelChartDataArgs = {
  date: Scalars['Date']['input'];
  filters?: InputMaybe<StudentListFilterInput>;
};


/** An organization, such as a college */
export type OrganizationLiveEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audience?: InputMaybe<Array<LiveEventAudienceEnum>>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatChannel?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  eventType?: InputMaybe<Array<LiveEventTypeEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<LiveEventOrderingInput>>;
  status?: InputMaybe<Array<LiveEventStatusEnum>>;
};


/** An organization, such as a college */
export type OrganizationMetricsArgs = {
  context: OrganizationMetricsContextEnum;
};


/** An organization, such as a college */
export type OrganizationStudentListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  argument: StudentListArgumentInput;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization, such as a college */
export type OrganizationStudentListTimeSeriesArgs = {
  argument: StudentListTimeSeriesArgumentInput;
};


/** An organization, such as a college */
export type OrganizationSurprisesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization, such as a college */
export type OrganizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPostedToFeed?: InputMaybe<Scalars['Boolean']['input']>;
  inclusions?: InputMaybe<Array<UserInclusionAttributeEnum>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  omissions?: InputMaybe<Array<UserOmissionAttributeEnum>>;
  ordering?: InputMaybe<Array<UserOrderingInput>>;
  roles?: InputMaybe<Array<UserRoleEnum>>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

/** A specific metric about an organization */
export type OrganizationMetric = {
  __typename?: 'OrganizationMetric';
  /** The name of the metric */
  name?: Maybe<Scalars['String']['output']>;
  /** The value of the metric during the last cycle at this time */
  previousCycleValue?: Maybe<Scalars['Double']['output']>;
  /** The current value of the metric */
  value?: Maybe<Scalars['Double']['output']>;
};

/** Context for which metrics can be retrieved */
export enum OrganizationMetricsContextEnum {
  /** Adoption metrics */
  Adoption = 'ADOPTION',
  /** Bulk message metrics */
  BulkMessages = 'BULK_MESSAGES',
  /** Community snapshot metrics */
  CommunitySnapshot = 'COMMUNITY_SNAPSHOT',
  /** Community tools metrics */
  CommunityTools = 'COMMUNITY_TOOLS',
  /** Engagement metrics */
  Engagement = 'ENGAGEMENT',
  /** Feed posts metrics */
  FeedPosts = 'FEED_POSTS',
  /** Games and live events metrics */
  LiveEvents = 'LIVE_EVENTS',
  /** Predictive models commit index metrics */
  PredictiveModelsCommitIndex = 'PREDICTIVE_MODELS_COMMIT_INDEX',
  /** Predictive models apply index metrics */
  RisePredictiveModelsApplyIndex = 'RISE_PREDICTIVE_MODELS_APPLY_INDEX',
  /** Predictive models commit index metrics */
  RisePredictiveModelsCommitIndex = 'RISE_PREDICTIVE_MODELS_COMMIT_INDEX',
  /** Predictive models melt index metrics */
  RisePredictiveModelsMeltIndex = 'RISE_PREDICTIVE_MODELS_MELT_INDEX',
  /** Predictive models retain index metrics */
  RisePredictiveModelsRetainIndex = 'RISE_PREDICTIVE_MODELS_RETAIN_INDEX',
  /** Predictive models yield index metrics */
  RisePredictiveModelsYieldIndex = 'RISE_PREDICTIVE_MODELS_YIELD_INDEX'
}

/** Ordering options for organizations */
export type OrganizationOrderingInput = {
  direction: SortDirectionEnum;
  field: OrganizationSortableFieldEnum;
};

/** Partnership level for organization */
export enum OrganizationPartnershipLevelEnum {
  /** Access to lite partnership level */
  Lite = 'LITE',
  /** Access to Premier partnership level */
  Premier = 'PREMIER',
  /** Access to Professional partnership level */
  Pro = 'PRO'
}

export type OrganizationPermission = {
  __typename?: 'OrganizationPermission';
  flags?: Maybe<Array<PartnerFeatureEnum>>;
  partnershipLevel?: Maybe<OrganizationPartnershipLevelEnum>;
};

/** Fields available for sorting organizations */
export enum OrganizationSortableFieldEnum {
  /** Sort by name */
  Name = 'NAME'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Feature flags for partner organizations */
export enum PartnerFeatureEnum {
  /** Access to bulk messaging */
  BulkMessaging = 'BULK_MESSAGING',
  /** Access to chat games feature */
  Games = 'GAMES',
  /** Access to RISE functionality */
  Rise = 'RISE',
  /** Access to RISE Predictive Models functionality */
  RisePredictiveModels = 'RISE_PREDICTIVE_MODELS'
}

/** Prediction index for student behavior */
export enum PredictionIndexEnum {
  /** High likelihood of behavior */
  High = 'HIGH',
  /** Low likelihood of behavior */
  Low = 'LOW',
  /** Medium likelihood of behavior */
  Medium = 'MEDIUM'
}

/** A summary of various prediction indexes for a particular student behavior */
export type PredictionIndexSummary = {
  __typename?: 'PredictionIndexSummary';
  /** High index students grouped by funnel state */
  high?: Maybe<Array<FunnelStateDataPoint>>;
  /** Low index students grouped by funnel state */
  low?: Maybe<Array<FunnelStateDataPoint>>;
  /** Medium index students grouped by funnel state */
  medium?: Maybe<Array<FunnelStateDataPoint>>;
};

/** A time series data point object */
export type PredictiveIndexTimeSeriesDataPoint = {
  __typename?: 'PredictiveIndexTimeSeriesDataPoint';
  date: Scalars['Date']['output'];
  index?: Maybe<PredictionIndexEnum>;
  value?: Maybe<Scalars['Double']['output']>;
};

/** Options for score trend predictions */
export enum PredictiveScoreTrendEnum {
  /** Downtrending */
  Downtrending = 'DOWNTRENDING',
  /** Uptrending */
  Uptrending = 'UPTRENDING'
}

/** A profile answer object */
export type ProfileAnswer = Node & {
  __typename?: 'ProfileAnswer';
  id: Scalars['ID']['output'];
  /** The question this answer belongs to */
  question: ProfileQuestion;
  text?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ProfileAnswer. */
export type ProfileAnswerConnection = {
  __typename?: 'ProfileAnswerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProfileAnswerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProfileAnswer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProfileAnswerEdge = {
  __typename?: 'ProfileAnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProfileAnswer>;
};

export enum ProfileAnswerFilterEnum {
  /** Only include fun-fact answers */
  FunFacts = 'FUN_FACTS'
}

/** Ordering options for profile answers */
export type ProfileAnswerOrderingInput = {
  direction: SortDirectionEnum;
  field: ProfileAnswerSortableFieldEnum;
};

/** Fields available for sorting profile answers */
export enum ProfileAnswerSortableFieldEnum {
  /** Sort by updated_at timestamp */
  UpdatedAt = 'UPDATED_AT'
}

/** A profile question object */
export type ProfileQuestion = Node & {
  __typename?: 'ProfileQuestion';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ProfileQuestion. */
export type ProfileQuestionConnection = {
  __typename?: 'ProfileQuestionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProfileQuestionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProfileQuestion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProfileQuestionEdge = {
  __typename?: 'ProfileQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProfileQuestion>;
};

export enum ProfileQuestionFilterEnum {
  /** Only include fun-fact questions */
  FunFacts = 'FUN_FACTS'
}

export type Query = {
  __typename?: 'Query';
  chatBaseUsers: Array<ChatBaseUserInterface>;
  /** The current cohort year */
  currentCohortYear: Scalars['Int']['output'];
  filestackPolicy: FileStackPolicy;
  /** List of all ice breaker groups */
  iceBreakerGroups: Array<Maybe<IceBreakerGroup>>;
  /** List of all interests available. */
  interests: InterestConnection;
  /** Search for cities. */
  locationCities: LocationCityConnection;
  /** List of all majors available. */
  majors: MajorConnection;
  /** Fetches the current user */
  me: User;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes?: Maybe<Array<Maybe<Node>>>;
  profileQuestions: ProfileQuestionConnection;
  /** List of all social media platforms currently available. */
  socialMediaPlatforms: SocialMediaHandlePlatformConnection;
  /** List of magic surprise objects */
  surprises?: Maybe<SurpriseConnection>;
};


export type QueryChatBaseUsersArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryFilestackPolicyArgs = {
  filepickerUrl?: InputMaybe<Scalars['String']['input']>;
  kind: FileStackPolicyKindEnum;
};


export type QueryInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationCitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryMajorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryProfileQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: ProfileQuestionFilterEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notAnsweredByUserId?: InputMaybe<Scalars['ID']['input']>;
  ordering: ProfileAnswerOrderingInput;
};


export type QuerySocialMediaPlatformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurprisesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category: SurpriseCategoryEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RecoverableError = {
  __typename?: 'RecoverableError';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveOfficialFromOrganizationMutation */
export type RemoveOfficialFromOrganizationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Relay ID of organization */
  organizationId: Scalars['ID']['input'];
  /** Relay ID of user to remove from organization */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOfficialFromOrganizationMutation. */
export type RemoveOfficialFromOrganizationMutationPayload = {
  __typename?: 'RemoveOfficialFromOrganizationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of ReplaceUserSocialsMutation */
export type ReplaceUserSocialsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Complete list of socials to persist for this user */
  socials: Array<SocialMediaHandleInput>;
  /** ID of the user whose socials are being updated */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReplaceUserSocialsMutation. */
export type ReplaceUserSocialsMutationPayload = {
  __typename?: 'ReplaceUserSocialsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  socials?: Maybe<Array<SocialMediaHandle>>;
};

/** Reasons for reporting content */
export enum ReportedContentReasonEnum {
  Bullying = 'BULLYING',
  FakeAccount = 'FAKE_ACCOUNT',
  PostingInappropriate = 'POSTING_INAPPROPRIATE',
  PostingSpam = 'POSTING_SPAM',
  SomethingElse = 'SOMETHING_ELSE',
  Stalking = 'STALKING'
}

/** Autogenerated input type of ResendDashInviteMutation */
export type ResendDashInviteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Relay ID of invitation to resend */
  dashInviteId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendDashInviteMutation. */
export type ResendDashInviteMutationPayload = {
  __typename?: 'ResendDashInviteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

export type RiseActionGroup = Node & {
  __typename?: 'RiseActionGroup';
  id: Scalars['ID']['output'];
  masterId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** RISE data specific to an organization */
export type RiseOrganization = {
  __typename?: 'RiseOrganization';
  /** Count of students grouped by funnel state */
  applyIndexSummary?: Maybe<RisePredictiveIndexSummary>;
  /** Count of students grouped by funnel state */
  commitIndexSummary?: Maybe<RisePredictiveIndexSummary>;
  /** Task generation has happened for this date */
  isActionGenerationComplete: Scalars['Boolean']['output'];
  /** Count of students grouped by funnel state */
  meltIndexSummary?: Maybe<RisePredictiveIndexSummary>;
  /** Count of students grouped by funnel state */
  retainIndexSummary?: Maybe<RisePredictiveIndexSummary>;
  /** Count of students grouped by funnel state */
  yieldIndexSummary?: Maybe<RisePredictiveIndexSummary>;
};


/** RISE data specific to an organization */
export type RiseOrganizationApplyIndexSummaryArgs = {
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
};


/** RISE data specific to an organization */
export type RiseOrganizationCommitIndexSummaryArgs = {
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
};


/** RISE data specific to an organization */
export type RiseOrganizationIsActionGenerationCompleteArgs = {
  date: Scalars['Date']['input'];
};


/** RISE data specific to an organization */
export type RiseOrganizationMeltIndexSummaryArgs = {
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
};


/** RISE data specific to an organization */
export type RiseOrganizationRetainIndexSummaryArgs = {
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
};


/** RISE data specific to an organization */
export type RiseOrganizationYieldIndexSummaryArgs = {
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
};

/** Predictive index options for RISE */
export enum RisePredictiveIndexEnum {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** Medium-High */
  MediumHigh = 'MEDIUM_HIGH',
  /** Medium-Low */
  MediumLow = 'MEDIUM_LOW'
}

/** A summary of various prediction indexes for a particular student behavior */
export type RisePredictiveIndexSummary = {
  __typename?: 'RisePredictiveIndexSummary';
  /** High index students grouped by funnel state */
  high?: Maybe<Array<FunnelStateDataPoint>>;
  /** Low index students grouped by funnel state */
  low?: Maybe<Array<FunnelStateDataPoint>>;
  /** Medium index students grouped by funnel state */
  medium?: Maybe<Array<FunnelStateDataPoint>>;
  /** Medium-High index students grouped by funnel state */
  mediumHigh?: Maybe<Array<FunnelStateDataPoint>>;
  /** Medium-Low index students grouped by funnel state */
  mediumLow?: Maybe<Array<FunnelStateDataPoint>>;
};

/** A time series data point object */
export type RisePredictiveIndexTimeSeriesDataPoint = {
  __typename?: 'RisePredictiveIndexTimeSeriesDataPoint';
  date: Scalars['Date']['output'];
  index?: Maybe<RisePredictiveIndexEnum>;
  value: Scalars['Double']['output'];
};

/** Predictive model options for RISE */
export enum RisePredictiveModelEnum {
  /** Apply */
  Apply = 'APPLY',
  /** Commit */
  Commit = 'COMMIT',
  /** Melt */
  Melt = 'MELT',
  /** Yield */
  Yield = 'YIELD'
}

/** RISE only data connected to student object */
export type RiseStudentData = {
  __typename?: 'RiseStudentData';
  applyScoreTimeSeries?: Maybe<Array<RisePredictiveIndexTimeSeriesDataPoint>>;
  commitScoreTimeSeries?: Maybe<Array<RisePredictiveIndexTimeSeriesDataPoint>>;
  meltScoreTimeSeries?: Maybe<Array<RisePredictiveIndexTimeSeriesDataPoint>>;
  retainScoreTimeSeries?: Maybe<Array<RisePredictiveIndexTimeSeriesDataPoint>>;
  todaysAction?: Maybe<RiseUserAction>;
  yieldScoreTimeSeries?: Maybe<Array<RisePredictiveIndexTimeSeriesDataPoint>>;
};


/** RISE only data connected to student object */
export type RiseStudentDataApplyScoreTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};


/** RISE only data connected to student object */
export type RiseStudentDataCommitScoreTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};


/** RISE only data connected to student object */
export type RiseStudentDataMeltScoreTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};


/** RISE only data connected to student object */
export type RiseStudentDataRetainScoreTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};


/** RISE only data connected to student object */
export type RiseStudentDataTodaysActionArgs = {
  organizationId: Scalars['ID']['input'];
};


/** RISE only data connected to student object */
export type RiseStudentDataYieldScoreTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};

/** Filters for RISE indices */
export type RiseStudentListFiltersInput = {
  applyIndex?: InputMaybe<Array<RisePredictiveIndexEnum>>;
  commitIndex?: InputMaybe<Array<RisePredictiveIndexEnum>>;
  downTrendingScores?: InputMaybe<Array<RisePredictiveModelEnum>>;
  meltIndex?: InputMaybe<Array<RisePredictiveIndexEnum>>;
  retainIndex?: InputMaybe<Array<RisePredictiveIndexEnum>>;
  upTrendingScores?: InputMaybe<Array<RisePredictiveModelEnum>>;
  yieldIndex?: InputMaybe<Array<RisePredictiveIndexEnum>>;
};

/** RISE predictive index filters for querying students */
export type RiseStudentListPredictiveIndexFilterInput = {
  currentIndex?: InputMaybe<RisePredictiveIndexEnum>;
  funnelStates?: InputMaybe<Array<FunnelStateEnum>>;
  inCommunity?: InputMaybe<YesNoEnum>;
  previousIndex?: InputMaybe<RisePredictiveIndexEnum>;
};

/** RISE only data connected to student organization status object */
export type RiseStudentOrganizationStatusData = {
  __typename?: 'RiseStudentOrganizationStatusData';
  applyIndex?: Maybe<RisePredictiveIndexEnum>;
  applyIndexChangedOn?: Maybe<Scalars['Date']['output']>;
  applyIndexChangedToHighOn?: Maybe<Scalars['Date']['output']>;
  applyIndexChangedToLowOn?: Maybe<Scalars['Date']['output']>;
  applyIndexChangedToMediumHighOn?: Maybe<Scalars['Date']['output']>;
  applyIndexChangedToMediumLowOn?: Maybe<Scalars['Date']['output']>;
  applyIndexChangedToMediumOn?: Maybe<Scalars['Date']['output']>;
  applyScore?: Maybe<Scalars['Double']['output']>;
  commitIndex?: Maybe<RisePredictiveIndexEnum>;
  commitIndexChangedOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToHighOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToLowOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToMediumHighOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToMediumLowOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToMediumOn?: Maybe<Scalars['Date']['output']>;
  commitScore?: Maybe<Scalars['Double']['output']>;
  meltIndex?: Maybe<RisePredictiveIndexEnum>;
  meltIndexChangedOn?: Maybe<Scalars['Date']['output']>;
  meltIndexChangedToHighOn?: Maybe<Scalars['Date']['output']>;
  meltIndexChangedToLowOn?: Maybe<Scalars['Date']['output']>;
  meltIndexChangedToMediumHighOn?: Maybe<Scalars['Date']['output']>;
  meltIndexChangedToMediumLowOn?: Maybe<Scalars['Date']['output']>;
  meltIndexChangedToMediumOn?: Maybe<Scalars['Date']['output']>;
  meltScore?: Maybe<Scalars['Double']['output']>;
  previousApplyIndex?: Maybe<RisePredictiveIndexEnum>;
  previousCommitIndex?: Maybe<RisePredictiveIndexEnum>;
  previousMeltIndex?: Maybe<RisePredictiveIndexEnum>;
  previousRetainIndex?: Maybe<RisePredictiveIndexEnum>;
  previousYieldIndex?: Maybe<RisePredictiveIndexEnum>;
  retainIndex?: Maybe<RisePredictiveIndexEnum>;
  retainIndexChangedOn?: Maybe<Scalars['Date']['output']>;
  retainIndexChangedToHighOn?: Maybe<Scalars['Date']['output']>;
  retainIndexChangedToLowOn?: Maybe<Scalars['Date']['output']>;
  retainIndexChangedToMediumHighOn?: Maybe<Scalars['Date']['output']>;
  retainIndexChangedToMediumLowOn?: Maybe<Scalars['Date']['output']>;
  retainIndexChangedToMediumOn?: Maybe<Scalars['Date']['output']>;
  retainScore?: Maybe<Scalars['Double']['output']>;
  riseUserActionStudentStatus?: Maybe<RiseUserActionStudentStatus>;
  yieldIndex?: Maybe<RisePredictiveIndexEnum>;
  yieldIndexChangedOn?: Maybe<Scalars['Date']['output']>;
  yieldIndexChangedToHighOn?: Maybe<Scalars['Date']['output']>;
  yieldIndexChangedToLowOn?: Maybe<Scalars['Date']['output']>;
  yieldIndexChangedToMediumHighOn?: Maybe<Scalars['Date']['output']>;
  yieldIndexChangedToMediumLowOn?: Maybe<Scalars['Date']['output']>;
  yieldIndexChangedToMediumOn?: Maybe<Scalars['Date']['output']>;
  yieldScore?: Maybe<Scalars['Double']['output']>;
};


/** RISE only data connected to student organization status object */
export type RiseStudentOrganizationStatusDataRiseUserActionStudentStatusArgs = {
  riseUserActionId: Scalars['ID']['input'];
};

export type RiseUserAction = Node & {
  __typename?: 'RiseUserAction';
  actionGroup: RiseActionGroup;
  actionType: RiseUserActionType;
  id: Scalars['ID']['output'];
  metrics?: Maybe<RiseUserActionMetrics>;
};

/** How much capacity this user has for rise actions */
export enum RiseUserActionCapacityEnum {
  /** High capacity */
  High = 'HIGH',
  /** Low capacity */
  Low = 'LOW',
  /** Medium capacity */
  Medium = 'MEDIUM'
}

/** The connection type for RiseUserAction. */
export type RiseUserActionConnection = {
  __typename?: 'RiseUserActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RiseUserActionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RiseUserAction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RiseUserActionEdge = {
  __typename?: 'RiseUserActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RiseUserAction>;
};

export enum RiseUserActionFilterEnum {
  /** Only include hidden actions */
  Hidden = 'HIDDEN',
  /** Only include visible actions */
  Visible = 'VISIBLE'
}

export type RiseUserActionGoal = Node & {
  __typename?: 'RiseUserActionGoal';
  /** Number of actions for today */
  goal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type RiseUserActionMetrics = {
  __typename?: 'RiseUserActionMetrics';
  doneCount: Scalars['Int']['output'];
  notDoneCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type RiseUserActionStudentStatus = Node & {
  __typename?: 'RiseUserActionStudentStatus';
  id: Scalars['ID']['output'];
  status: RiseUserActionStudentStatusEnum;
};

/** The status of this action for a student */
export enum RiseUserActionStudentStatusEnum {
  /** Action is complete */
  Done = 'DONE',
  /** Action has not been completed */
  NotDone = 'NOT_DONE',
  /** Action skipped */
  Skipped = 'SKIPPED'
}

export type RiseUserActionType = Node & {
  __typename?: 'RiseUserActionType';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  masterId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** RISE only data connected to user object */
export type RiseUserData = {
  __typename?: 'RiseUserData';
  actionGoal?: Maybe<RiseUserActionGoal>;
};


/** RISE only data connected to user object */
export type RiseUserDataActionGoalArgs = {
  date: Scalars['Date']['input'];
  organizationId: Scalars['ID']['input'];
};

/** A social media handle */
export type SocialMediaHandle = Node & {
  __typename?: 'SocialMediaHandle';
  /** The users username or handle on that platform */
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The social network/platform */
  platform?: Maybe<SocialMediaHandlePlatform>;
};

/** The connection type for SocialMediaHandle. */
export type SocialMediaHandleConnection = {
  __typename?: 'SocialMediaHandleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SocialMediaHandleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SocialMediaHandle>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SocialMediaHandleEdge = {
  __typename?: 'SocialMediaHandleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SocialMediaHandle>;
};

/** A social media handle for a specific platform */
export type SocialMediaHandleInput = {
  /** The username/handle on that platform */
  handle: Scalars['String']['input'];
  /** ID of the social media platform */
  platformId: Scalars['ID']['input'];
};

/** A social media platform */
export type SocialMediaHandlePlatform = Node & {
  __typename?: 'SocialMediaHandlePlatform';
  baseUrl?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Image>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for SocialMediaHandlePlatform. */
export type SocialMediaHandlePlatformConnection = {
  __typename?: 'SocialMediaHandlePlatformConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SocialMediaHandlePlatformEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SocialMediaHandlePlatform>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SocialMediaHandlePlatformEdge = {
  __typename?: 'SocialMediaHandlePlatformEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SocialMediaHandlePlatform>;
};

/** The direction in which to sort */
export enum SortDirectionEnum {
  /** Sort in ascending order */
  Asc = 'ASC',
  /** Sort in descending order */
  Desc = 'DESC'
}

/** Autogenerated input type of StopBulkMessageMutation */
export type StopBulkMessageMutationInput = {
  bulkMessageId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StopBulkMessageMutation. */
export type StopBulkMessageMutationPayload = {
  __typename?: 'StopBulkMessageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  success: Scalars['Boolean']['output'];
};

/** A student user object */
export type Student = ChatBaseUserInterface & Node & {
  __typename?: 'Student';
  commitScoreTimeSeries?: Maybe<Array<PredictiveIndexTimeSeriesDataPoint>>;
  /** @deprecated Does not work for all user names */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Interests associated with this student */
  interests?: Maybe<InterestConnection>;
  /** @deprecated Does not work for all user names */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Majors associated with this student */
  majors?: Maybe<MajorConnection>;
  name?: Maybe<Scalars['String']['output']>;
  /** Profile answers associated with the student */
  profileAnswers?: Maybe<ProfileAnswerConnection>;
  /** The students profile photo */
  profilePhoto?: Maybe<Image>;
  rise?: Maybe<RiseStudentData>;
  /** All social media platforms this student has added handles for */
  socials?: Maybe<SocialMediaHandleConnection>;
  /** Data derived from the relationship between this student and the given organization */
  studentOrganizationStatus?: Maybe<StudentOrganizationStatus>;
  uuid: Scalars['String']['output'];
};


/** A student user object */
export type StudentCommitScoreTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};


/** A student user object */
export type StudentInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A student user object */
export type StudentMajorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A student user object */
export type StudentProfileAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: ProfileAnswerFilterEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<ProfileAnswerOrderingInput>;
};


/** A student user object */
export type StudentSocialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A student user object */
export type StudentStudentOrganizationStatusArgs = {
  organizationId: Scalars['ID']['input'];
};

/** The connection type for Student. */
export type StudentConnection = {
  __typename?: 'StudentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StudentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Student>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StudentEdge = {
  __typename?: 'StudentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Student>;
};

/** Filtering & ordering options for bulk messages */
export type StudentListArgumentBulkMessagesInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListBulkMessagesOrderingOneOfInput>>;
};

/** Filtering & ordering options for channel opens */
export type StudentListArgumentChannelOpensInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListChannelOpensOrderingOneOfInput>>;
};

/** Filtering & ordering options for commit index */
export type StudentListArgumentCommitIndexInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListCommitIndexOrderingOneOfInput>>;
};

/** Filtering & ordering options for community tools */
export type StudentListArgumentCommunityToolsInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListCommunityToolsOrderingOneOfInput>>;
};

/** Filtering & ordering options for direct messages */
export type StudentListArgumentDirectMessagesInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListDirectMessagesOrderingOneOfInput>>;
};

/** Filtering & ordering options for feed posts */
export type StudentListArgumentFeedPostViewsInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListFeedPostViewsOrderingOneOfInput>>;
};

/** Filtering & ordering options for feed posts */
export type StudentListArgumentFeedPostsInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListFeedPostsOrderingOneOfInput>>;
};

/** Filtering & ordering options for the funnel chart */
export type StudentListArgumentFunnelChartInput = {
  filters: StudentListFilterInput;
  funnelChartDate: Scalars['Date']['input'];
  funnelChartFunnelStates?: InputMaybe<Array<FunnelStateEnum>>;
  ordering?: InputMaybe<Array<StudentListOrganizationOrderingInput>>;
};

/** Filtering & ordering options for group chats */
export type StudentListArgumentGroupChatsInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListGroupChatsOrderingOneOfInput>>;
};

/** Student list argument input */
export type StudentListArgumentInput =
  { bulkMessages: StudentListArgumentBulkMessagesInput; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens: StudentListArgumentChannelOpensInput; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex: StudentListArgumentCommitIndexInput; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools: StudentListArgumentCommunityToolsInput; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages: StudentListArgumentDirectMessagesInput; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews: StudentListArgumentFeedPostViewsInput; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts: StudentListArgumentFeedPostsInput; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart: StudentListArgumentFunnelChartInput; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats: StudentListArgumentGroupChatsInput; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent: StudentListArgumentLiveEventInput; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents: StudentListArgumentLiveEventsInput; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged: StudentListArgumentMostEngagedInput; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization: StudentListArgumentOrganizationInput; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews: StudentListArgumentProfileViewsInput; rise?: never; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise: StudentListArgumentRiseInput; roommateMatchFriendFinderSearches?: never; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches: StudentListArgumentRoommateMatchFriendFinderSearchesInput; search?: never; }
  |  { bulkMessages?: never; channelOpens?: never; commitIndex?: never; communityTools?: never; directMessages?: never; feedPostViews?: never; feedPosts?: never; funnelChart?: never; groupChats?: never; liveEvent?: never; liveEvents?: never; mostEngaged?: never; organization?: never; profileViews?: never; rise?: never; roommateMatchFriendFinderSearches?: never; search: StudentListArgumentSearchInput; };

/** Arguments for listing students scoped to a live event */
export type StudentListArgumentLiveEventInput = {
  filters: StudentListFilterInput;
  /** The funnel state of students during the event */
  liveEventFunnelStates?: InputMaybe<Array<FunnelStateEnum>>;
  liveEventId: Scalars['ID']['input'];
  ordering?: InputMaybe<Array<StudentListOrganizationOrderingInput>>;
};

export type StudentListArgumentLiveEventsInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListLiveEventsOrderingOneOfInput>>;
};

/** Filtering & ordering options for most engaged students */
export type StudentListArgumentMostEngagedInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListMostEngagedOrderingOneOfInput>>;
};

/** Arguments for listing students scoped to an organization */
export type StudentListArgumentOrganizationInput = {
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListOrganizationOrderingInput>>;
};

/** Filtering & ordering options for profile views */
export type StudentListArgumentProfileViewsInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListProfileViewsOrderingOneOfInput>>;
};

/** Filtering & ordering options for strategy board action details */
export type StudentListArgumentRiseActionDetailsInput = {
  ordering?: InputMaybe<Array<StudentListRiseActionDetailsOrderingInput>>;
  riseUserActionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filtering & ordering options for apply index */
export type StudentListArgumentRiseApplyIndexInput = {
  filters?: InputMaybe<RiseStudentListPredictiveIndexFilterInput>;
  ordering?: InputMaybe<Array<StudentListRisePredictiveIndexOrderingInput>>;
};

/** Filtering & ordering options for commit index */
export type StudentListArgumentRiseCommitIndexInput = {
  filters?: InputMaybe<RiseStudentListPredictiveIndexFilterInput>;
  ordering?: InputMaybe<Array<StudentListRisePredictiveIndexOrderingInput>>;
};

export type StudentListArgumentRiseInput =
  { actionDetails: StudentListArgumentRiseActionDetailsInput; applyIndex?: never; commitIndex?: never; meltIndex?: never; retainIndex?: never; yieldIndex?: never; }
  |  { actionDetails?: never; applyIndex: StudentListArgumentRiseApplyIndexInput; commitIndex?: never; meltIndex?: never; retainIndex?: never; yieldIndex?: never; }
  |  { actionDetails?: never; applyIndex?: never; commitIndex: StudentListArgumentRiseCommitIndexInput; meltIndex?: never; retainIndex?: never; yieldIndex?: never; }
  |  { actionDetails?: never; applyIndex?: never; commitIndex?: never; meltIndex: StudentListArgumentRiseMeltIndexInput; retainIndex?: never; yieldIndex?: never; }
  |  { actionDetails?: never; applyIndex?: never; commitIndex?: never; meltIndex?: never; retainIndex: StudentListArgumentRiseRetainIndexInput; yieldIndex?: never; }
  |  { actionDetails?: never; applyIndex?: never; commitIndex?: never; meltIndex?: never; retainIndex?: never; yieldIndex: StudentListArgumentRiseYieldIndexInput; };

/** Filtering & ordering options for melt index */
export type StudentListArgumentRiseMeltIndexInput = {
  filters?: InputMaybe<RiseStudentListPredictiveIndexFilterInput>;
  ordering?: InputMaybe<Array<StudentListRisePredictiveIndexOrderingInput>>;
};

/** Filtering & ordering options for retain index */
export type StudentListArgumentRiseRetainIndexInput = {
  filters?: InputMaybe<RiseStudentListPredictiveIndexFilterInput>;
  ordering?: InputMaybe<Array<StudentListRisePredictiveIndexOrderingInput>>;
};

/** Filtering & ordering options for yield index */
export type StudentListArgumentRiseYieldIndexInput = {
  filters?: InputMaybe<RiseStudentListPredictiveIndexFilterInput>;
  ordering?: InputMaybe<Array<StudentListRisePredictiveIndexOrderingInput>>;
};

/** Filtering & ordering options for roommate match friend finder searches */
export type StudentListArgumentRoommateMatchFriendFinderSearchesInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  filters: StudentListFilterInput;
  ordering?: InputMaybe<Array<StudentListRoommateMatchFriendFinderSearchesOrderingOneOfInput>>;
};

/** Arguments for searching students */
export type StudentListArgumentSearchInput = {
  inCommunity?: InputMaybe<YesNoEnum>;
  name: Scalars['String']['input'];
  searchingUserId: Scalars['ID']['input'];
};

/** Ordering for bulk message users */
export type StudentListBulkMessagesOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListBulkMessagesSortableFieldEnum;
};

/** Union of possible ordering inputs for bulk messages student list */
export type StudentListBulkMessagesOrderingOneOfInput =
  { bulkMessageOrdering: StudentListBulkMessagesOrderingInput; organizationOrdering?: never; }
  |  { bulkMessageOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListBulkMessagesSortableFieldEnum {
  /** Sort by most recently contacted users */
  BulkMessagesRecentlyContacted = 'BULK_MESSAGES_RECENTLY_CONTACTED'
}

/** Ordering for channel open users */
export type StudentListChannelOpensOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListChannelOpensSortableFieldEnum;
};

/** Union of possible ordering inputs for channel opens student list */
export type StudentListChannelOpensOrderingOneOfInput =
  { channelOpensOrdering: StudentListChannelOpensOrderingInput; organizationOrdering?: never; }
  |  { channelOpensOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListChannelOpensSortableFieldEnum {
  /** Sort by channel open time */
  LastChannelOpenedAt = 'LAST_CHANNEL_OPENED_AT'
}

/** Ordering for commit index */
export type StudentListCommitIndexOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListCommitIndexSortableFieldEnum;
};

/** Union of possible ordering inputs for commit index student list */
export type StudentListCommitIndexOrderingOneOfInput =
  { commitIndexOrdering: StudentListCommitIndexOrderingInput; organizationOrdering?: never; }
  |  { commitIndexOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListCommitIndexSortableFieldEnum {
  /** Sort by date index changed to high */
  CommitIndexChangedToHighAt = 'COMMIT_INDEX_CHANGED_TO_HIGH_AT',
  /** Sort by date index changed to low */
  CommitIndexChangedToLowAt = 'COMMIT_INDEX_CHANGED_TO_LOW_AT',
  /** Sort by date index changed to medium */
  CommitIndexChangedToMediumAt = 'COMMIT_INDEX_CHANGED_TO_MEDIUM_AT',
  /** Sort by commit score */
  CommitScore = 'COMMIT_SCORE',
  /** Sort by last contacted at */
  LastContactedAt = 'LAST_CONTACTED_AT',
  /** Sort by previous commit index */
  PreviousCommitIndex = 'PREVIOUS_COMMIT_INDEX'
}

/** Ordering for community tools users */
export type StudentListCommunityToolsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListCommunityToolsSortableFieldEnum;
};

/** Union of possible ordering inputs for community tools student list */
export type StudentListCommunityToolsOrderingOneOfInput =
  { communityToolsOrdering: StudentListCommunityToolsOrderingInput; organizationOrdering?: never; }
  |  { communityToolsOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListCommunityToolsSortableFieldEnum {
  /** Sort by most recently reached users by any community tool */
  RecentlyReachedAt = 'RECENTLY_REACHED_AT'
}

/** Ordering for direct message users */
export type StudentListDirectMessagesOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListDirectMessagesSortableFieldEnum;
};

/** Union of possible ordering inputs for direct messages */
export type StudentListDirectMessagesOrderingOneOfInput =
  { directMessagesOrdering: StudentListDirectMessagesOrderingInput; organizationOrdering?: never; }
  |  { directMessagesOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListDirectMessagesSortableFieldEnum {
  /** Sort by direct message sent time */
  LastDirectMessageSentAt = 'LAST_DIRECT_MESSAGE_SENT_AT'
}

/** Ordering for feed post users by views */
export type StudentListFeedPostViewsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListFeedPostViewsSortableFieldEnum;
};

/** Union of possible ordering inputs for feed posts student list */
export type StudentListFeedPostViewsOrderingOneOfInput =
  { feedPostViewsOrdering: StudentListFeedPostViewsOrderingInput; organizationOrdering?: never; }
  |  { feedPostViewsOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListFeedPostViewsSortableFieldEnum {
  /** Sort by feed post view time */
  LastFeedPostViewedAt = 'LAST_FEED_POST_VIEWED_AT'
}

/** Ordering for feed post users */
export type StudentListFeedPostsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListFeedPostsSortableFieldEnum;
};

/** Union of possible ordering inputs for feed posts student list */
export type StudentListFeedPostsOrderingOneOfInput =
  { feedPostsOrdering: StudentListFeedPostsOrderingInput; organizationOrdering?: never; }
  |  { feedPostsOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListFeedPostsSortableFieldEnum {
  /** Sort by feed post view time */
  LastFeedPostViewedAt = 'LAST_FEED_POST_VIEWED_AT',
  /**
   * Sort by feed post view time
   * @deprecated Not specific enough
   */
  ViewedAt = 'VIEWED_AT'
}

/** Filters for querying students */
export type StudentListFilterInput = {
  /**
   * Whether student is admitted but marked going elsewhere
   * @deprecated Use goingElsewhere instead
   */
  admittedButGoingElsewhere?: InputMaybe<YesNoEnum>;
  /**
   * Whether student is admitted but more active elsewhere
   * @deprecated Use moreActiveElsewhere instead
   */
  admittedButMoreActiveElsewhere?: InputMaybe<YesNoEnum>;
  /** Student who has these assigned counselors */
  assignedCounselors?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether student attended a live event */
  attendedALiveEvent?: InputMaybe<YesNoEnum>;
  /** Whether student has visited campus */
  campusVisit?: InputMaybe<YesNoEnum>;
  /** Student with the given ceeb code */
  ceebCode?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Student with given cohort year */
  cohortYear?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Student who commited within the given date range */
  commitDate?: InputMaybe<DateRangeInput>;
  /** Student with the given commit index */
  commitIndex?: InputMaybe<Array<PredictionIndexEnum>>;
  /** Student with the given commit score trend prediction */
  commitScoreTrend?: InputMaybe<PredictiveScoreTrendEnum>;
  /** Student with the given country classification */
  country?: InputMaybe<Array<CountryClassificationEnum>>;
  /** Whether student has deposited */
  deposited?: InputMaybe<YesNoEnum>;
  /** Whether student has direct admission */
  directAdmission?: InputMaybe<YesNoEnum>;
  engagementPercentile?: InputMaybe<EngagementPercentileEnum>;
  /** Student with the given entry term */
  entryTerm?: InputMaybe<Array<EntryTermEnum>>;
  /** Whether student completed fafsa */
  fafsaCompletionStatus?: InputMaybe<Array<FafsaCompletionStatusEnum>>;
  /** Whether student is first generation */
  firstGeneration?: InputMaybe<YesNoEnum>;
  /** Student with the given funnel states */
  funnelStates?: InputMaybe<Array<FunnelStateEnum>>;
  /** Student with the given gender */
  gender?: InputMaybe<Array<GenderEnum>>;
  /** Whether student is marked going elsewhere */
  goingElsewhere?: InputMaybe<YesNoEnum>;
  /** Student with the given going status */
  goingStatus?: InputMaybe<Array<GoingStatusEnum>>;
  /** Whether student has profile photo */
  hasProfilePhoto?: InputMaybe<YesNoEnum>;
  /** Student with the given community status */
  inCommunity?: InputMaybe<YesNoEnum>;
  /** Student with the given interest */
  interests?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Student who joined within the given date range */
  joinDate?: InputMaybe<DateRangeInput>;
  /** Student with the given join state */
  joinState?: InputMaybe<Array<JoinStateEnum>>;
  /** Student with the given join type */
  joinType?: InputMaybe<Array<JoinTypeEnum>>;
  /** Student with the given lead source */
  leadSource?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Student with the given major */
  majors?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether student is more active elsewhere */
  moreActiveElsewhere?: InputMaybe<YesNoEnum>;
  /** Student with the given commit index */
  previousCommitIndex?: InputMaybe<Array<PredictionIndexEnum>>;
  rise?: InputMaybe<RiseStudentListFiltersInput>;
  /** Student with the given state */
  state?: InputMaybe<Array<UnitedStatesStateEnum>>;
  /** Whether student athlete */
  studentAthlete?: InputMaybe<YesNoEnum>;
  /** Student with the given student type */
  studentType?: InputMaybe<Array<StudentTypeEnum>>;
  /** Student with the given zip code */
  zipCode?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Ordering inputs for group chat users */
export type StudentListGroupChatsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListGroupChatsSortableFieldEnum;
};

/** Union of possible ordering inputs for group chats */
export type StudentListGroupChatsOrderingOneOfInput =
  { groupChatsOrdering: StudentListGroupChatsOrderingInput; organizationOrdering?: never; }
  |  { groupChatsOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListGroupChatsSortableFieldEnum {
  /** Sort by group chat sent time */
  LastGroupChatSentAt = 'LAST_GROUP_CHAT_SENT_AT'
}

/** Ordering for live events users */
export type StudentListLiveEventsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListLiveEventsSortableFieldEnum;
};

/** Union of possible ordering inputs for live events student list */
export type StudentListLiveEventsOrderingOneOfInput =
  { liveEventsOrdering: StudentListLiveEventsOrderingInput; organizationOrdering?: never; }
  |  { liveEventsOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

export enum StudentListLiveEventsSortableFieldEnum {
  /** Sort by when users last participated in a live event */
  LiveEventsParticipatedAt = 'LIVE_EVENTS_PARTICIPATED_AT'
}

/** Ordering for most engaged student list */
export type StudentListMostEngagedOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListMostEngagedSortableFieldEnum;
};

/** Union of possible ordering inputs for most engaged student list */
export type StudentListMostEngagedOrderingOneOfInput =
  { mostEngagedOrdering: StudentListMostEngagedOrderingInput; organizationOrdering?: never; }
  |  { mostEngagedOrdering?: never; organizationOrdering: StudentListOrganizationOrderingInput; };

/** Fields by which the most engaged list may be sorted */
export enum StudentListMostEngagedSortableFieldEnum {
  /** Sort by messages sent */
  MessagesSent = 'MESSAGES_SENT'
}

/** Ordering options for organization-based student lists */
export type StudentListOrganizationOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListOrganizationSortableFieldEnum;
};

/** Fields available for sorting organization student lists */
export enum StudentListOrganizationSortableFieldEnum {
  /** Sort by assigned counselor */
  AssignedCounselor = 'ASSIGNED_COUNSELOR',
  /** Sort by cohort year */
  CohortYear = 'COHORT_YEAR',
  /** Sort by commit index */
  CommitIndex = 'COMMIT_INDEX',
  /** Sort by funnel state */
  FunnelState = 'FUNNEL_STATE',
  /** Sort by going status */
  GoingStatus = 'GOING_STATUS',
  /** Sort by joined at date */
  JoinedAt = 'JOINED_AT',
  /** Sort by last active timestamp */
  LastActive = 'LAST_ACTIVE',
  /** Sort by location */
  Location = 'LOCATION',
  /** Sort by student name */
  Name = 'NAME',
  /** Sort by phone number */
  Phone = 'PHONE',
  /** Sort by RISE apply index */
  RiseApplyIndex = 'RISE_APPLY_INDEX',
  /** Sort by RISE commit index */
  RiseCommitIndex = 'RISE_COMMIT_INDEX',
  /** Sort by RISE melt index */
  RiseMeltIndex = 'RISE_MELT_INDEX',
  /** Sort by RISE retain index */
  RiseRetainIndex = 'RISE_RETAIN_INDEX',
  /** Sort by RISE yield index */
  RiseYieldIndex = 'RISE_YIELD_INDEX',
  /** Sort by student status */
  Status = 'STATUS',
  /** Sort by student type */
  StudentType = 'STUDENT_TYPE'
}

/** Ordering for profile view users */
export type StudentListProfileViewsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListProfileViewsSortableFieldEnum;
};

/** Union of possible ordering inputs for profile views student list */
export type StudentListProfileViewsOrderingOneOfInput =
  { organizationOrdering: StudentListOrganizationOrderingInput; profileViewsOrdering?: never; }
  |  { organizationOrdering?: never; profileViewsOrdering: StudentListProfileViewsOrderingInput; };

export enum StudentListProfileViewsSortableFieldEnum {
  /** Sort by profile view time */
  LastProfileViewedAt = 'LAST_PROFILE_VIEWED_AT'
}

/** Ordering for feed post users */
export type StudentListRiseActionDetailsOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListRiseActionDetailsSortableFieldEnum;
};

export enum StudentListRiseActionDetailsSortableFieldEnum {
  /** Sort by funnel state */
  FunnelState = 'FUNNEL_STATE',
  /** Sort by going status */
  GoingStatus = 'GOING_STATUS',
  /** Sort by student name */
  Name = 'NAME',
  /** Sort by action status */
  Status = 'STATUS'
}

/** Ordering for RISE predictive indicies */
export type StudentListRisePredictiveIndexOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListRisePredictiveIndexSortableFieldEnum;
};

export enum StudentListRisePredictiveIndexSortableFieldEnum {
  /** Sort by date RISE index changed to high */
  RisePredictiveIndexChangedToHighAt = 'RISE_PREDICTIVE_INDEX_CHANGED_TO_HIGH_AT',
  /** Sort by date RISE changed to low */
  RisePredictiveIndexChangedToLowAt = 'RISE_PREDICTIVE_INDEX_CHANGED_TO_LOW_AT',
  /** Sort by date RISE index changed to medium */
  RisePredictiveIndexChangedToMediumAt = 'RISE_PREDICTIVE_INDEX_CHANGED_TO_MEDIUM_AT',
  /** Sort by date RISE index changed to medium high */
  RisePredictiveIndexChangedToMediumHighAt = 'RISE_PREDICTIVE_INDEX_CHANGED_TO_MEDIUM_HIGH_AT',
  /** Sort by date RISE changed to medium low */
  RisePredictiveIndexChangedToMediumLowAt = 'RISE_PREDICTIVE_INDEX_CHANGED_TO_MEDIUM_LOW_AT',
  /** Sort by RISE community status */
  RisePredictiveIndexCommunityStatus = 'RISE_PREDICTIVE_INDEX_COMMUNITY_STATUS',
  /** Sort by RISE funnel state */
  RisePredictiveIndexFunnelState = 'RISE_PREDICTIVE_INDEX_FUNNEL_STATE',
  /** Sort by RISE index student name */
  RisePredictiveIndexName = 'RISE_PREDICTIVE_INDEX_NAME',
  /** Sort by RISE previous index */
  RisePredictiveIndexPreviousIndex = 'RISE_PREDICTIVE_INDEX_PREVIOUS_INDEX',
  /** Sort by RISE index score */
  RisePredictiveIndexScore = 'RISE_PREDICTIVE_INDEX_SCORE'
}

/** Ordering for roommate match friend finder search users */
export type StudentListRoommateMatchFriendFinderSearchesOrderingInput = {
  direction: SortDirectionEnum;
  field: StudentListRoommateMatchFriendFinderSearchesSortableFieldEnum;
};

/** Union of possible ordering inputs for roommate match friend finder searches student list */
export type StudentListRoommateMatchFriendFinderSearchesOrderingOneOfInput =
  { organizationOrdering: StudentListOrganizationOrderingInput; roommateMatchFriendFinderSearchesOrdering?: never; }
  |  { organizationOrdering?: never; roommateMatchFriendFinderSearchesOrdering: StudentListRoommateMatchFriendFinderSearchesOrderingInput; };

export enum StudentListRoommateMatchFriendFinderSearchesSortableFieldEnum {
  /** Sort by search time */
  LastRmffSearchedAt = 'LAST_RMFF_SEARCHED_AT'
}

/** Student list argument time series input */
export type StudentListTimeSeriesArgumentInput =
  { channelOpens: StudentListTimeSeriesArgumentOrganizationInput; communityGrowth?: never; directMessages?: never; feedPostViews?: never; groupChats?: never; profileViews?: never; roommateMatchFriendFinderSearches?: never; }
  |  { channelOpens?: never; communityGrowth: StudentListTimeSeriesArgumentOrganizationInput; directMessages?: never; feedPostViews?: never; groupChats?: never; profileViews?: never; roommateMatchFriendFinderSearches?: never; }
  |  { channelOpens?: never; communityGrowth?: never; directMessages: StudentListTimeSeriesArgumentOrganizationInput; feedPostViews?: never; groupChats?: never; profileViews?: never; roommateMatchFriendFinderSearches?: never; }
  |  { channelOpens?: never; communityGrowth?: never; directMessages?: never; feedPostViews: StudentListTimeSeriesArgumentOrganizationInput; groupChats?: never; profileViews?: never; roommateMatchFriendFinderSearches?: never; }
  |  { channelOpens?: never; communityGrowth?: never; directMessages?: never; feedPostViews?: never; groupChats: StudentListTimeSeriesArgumentOrganizationInput; profileViews?: never; roommateMatchFriendFinderSearches?: never; }
  |  { channelOpens?: never; communityGrowth?: never; directMessages?: never; feedPostViews?: never; groupChats?: never; profileViews: StudentListTimeSeriesArgumentOrganizationInput; roommateMatchFriendFinderSearches?: never; }
  |  { channelOpens?: never; communityGrowth?: never; directMessages?: never; feedPostViews?: never; groupChats?: never; profileViews?: never; roommateMatchFriendFinderSearches: StudentListTimeSeriesArgumentOrganizationInput; };

/** Filter input for a time series metric over student list */
export type StudentListTimeSeriesArgumentOrganizationInput = {
  dateRange: DateRangeInput;
  filters: StudentListFilterInput;
};

/** A student organization status object */
export type StudentOrganizationStatus = {
  __typename?: 'StudentOrganizationStatus';
  assignedCounselor?: Maybe<User>;
  becameUninterestedOn?: Maybe<Scalars['Date']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  cohortYear?: Maybe<Scalars['Int']['output']>;
  commitIndex?: Maybe<PredictionIndexEnum>;
  commitIndexChangedOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToHighOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToLowOn?: Maybe<Scalars['Date']['output']>;
  commitIndexChangedToMediumOn?: Maybe<Scalars['Date']['output']>;
  commitPercentile?: Maybe<Scalars['Double']['output']>;
  commitScore?: Maybe<Scalars['Double']['output']>;
  /** @deprecated Performance. Use commitScoreTimeSeries on the Student type instead. */
  commitScoreTimeSeries?: Maybe<Array<PredictiveIndexTimeSeriesDataPoint>>;
  crmId?: Maybe<Scalars['String']['output']>;
  crmUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entryTerm?: Maybe<EntryTermEnum>;
  fafsaCompletionStatus?: Maybe<FafsaCompletionStatusEnum>;
  /** @deprecated Does not work for all user names */
  firstName?: Maybe<Scalars['String']['output']>;
  funnelState?: Maybe<FunnelStateEnum>;
  funnelStateTransitionSummary?: Maybe<Array<FunnelStateTransitionDate>>;
  goingStatus?: Maybe<GoingStatusEnum>;
  goingStatusChangedOn?: Maybe<Scalars['Date']['output']>;
  hasTakenRoommateQuiz?: Maybe<YesNoEnum>;
  highSchool?: Maybe<Scalars['String']['output']>;
  inCommunity?: Maybe<YesNoEnum>;
  interested?: Maybe<YesNoEnum>;
  joinType?: Maybe<JoinTypeEnum>;
  joinedOn?: Maybe<Scalars['Date']['output']>;
  lastActiveAt?: Maybe<Scalars['Double']['output']>;
  /** @deprecated Does not work for all user names */
  lastName?: Maybe<Scalars['String']['output']>;
  liveEventsAttended?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lookingForRoommate?: Maybe<YesNoEnum>;
  messagesSent?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  previousCommitIndex?: Maybe<PredictionIndexEnum>;
  rise?: Maybe<RiseStudentOrganizationStatusData>;
  schoolsAdmittedTo?: Maybe<Scalars['Int']['output']>;
  schoolsFollowing?: Maybe<Scalars['Int']['output']>;
  studentType?: Maybe<StudentTypeEnum>;
  uuid?: Maybe<Scalars['String']['output']>;
  visitedCampus?: Maybe<YesNoEnum>;
};

/** The transfer status of a student */
export enum StudentTypeEnum {
  /** First year */
  FirstYear = 'FIRST_YEAR',
  /** Transfer */
  Transfer = 'TRANSFER'
}

/** Represents surprise triggers, images, and emojis */
export type Surprise = Node & {
  __typename?: 'Surprise';
  /** List of emojis associated with the surprise */
  emojis?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the surprise should only trigger on exact matches */
  exactMatch?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Images associated with the surprise */
  images?: Maybe<Array<Image>>;
  /** Name of the surprise */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization that the surprise belongs to */
  organization?: Maybe<Organization>;
  /** List of phrases that trigger the surprise */
  triggerPhrases?: Maybe<Array<Scalars['String']['output']>>;
};

/** Category type of surprise */
export enum SurpriseCategoryEnum {
  /** Shows in all chats */
  Generic = 'GENERIC'
}

/** The connection type for Surprise. */
export type SurpriseConnection = {
  __typename?: 'SurpriseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurpriseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Surprise>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SurpriseEdge = {
  __typename?: 'SurpriseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Surprise>;
};

/** A time series data point object */
export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  date: Scalars['Date']['output'];
  value: Scalars['Double']['output'];
};

/** A unit type to specify that a side effect occur */
export enum UnitEnum {
  Unit = 'UNIT'
}

/** All U.S. States and inhabited Territories (including Washington, D.C.) */
export enum UnitedStatesStateEnum {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

/** Autogenerated input type of UpdateBulkMessageMutation */
export type UpdateBulkMessageMutationInput = {
  bulkMessageId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<BulkMessageFilterInput>;
  messageParts?: InputMaybe<Array<MessagePartInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendOption?: InputMaybe<BulkMessageSendOptionInput>;
  sender?: InputMaybe<BulkMessageSenderInput>;
};

/** Autogenerated return type of UpdateBulkMessageMutation. */
export type UpdateBulkMessageMutationPayload = {
  __typename?: 'UpdateBulkMessageMutationPayload';
  bulkMessage?: Maybe<BulkMessage>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of UpdateFeedPostMutation */
export type UpdateFeedPostMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input for updating a feed post */
  input: UpdateFeedPostOneOfInput;
};

/** Autogenerated return type of UpdateFeedPostMutation. */
export type UpdateFeedPostMutationPayload = {
  __typename?: 'UpdateFeedPostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  feedPost?: Maybe<FeedPost>;
};

/** Input for updating feed posts. */
export type UpdateFeedPostOneOfInput =
  /** Update a photo feed post */
  { photo: UpdateFeedPostPhotoInput; video?: never; }
  |  /** Update a video feed post */
  { photo?: never; video: UpdateFeedPostVideoInput; };

/** Input for updating photo feed posts */
export type UpdateFeedPostPhotoInput = {
  /** Optional caption */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** CTA button label */
  ctaText?: InputMaybe<Scalars['String']['input']>;
  /** CTA button URL */
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** If true, save as draft */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON as string from FilePicker */
  filepickerBlob?: InputMaybe<Scalars['String']['input']>;
  /** ID of the feed post (story answer) to update */
  id: Scalars['ID']['input'];
  /** Height of the uploaded image */
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Width of the uploaded image */
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  /** Internal name of the post */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Org official to post as */
  postedByOfficialId?: InputMaybe<Scalars['ID']['input']>;
  /** Date to publish post at. */
  publishAt?: InputMaybe<Scalars['Double']['input']>;
};

/** Input for updating video feed posts */
export type UpdateFeedPostVideoInput = {
  /** Optional caption */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** CTA button label */
  ctaText?: InputMaybe<Scalars['String']['input']>;
  /** CTA button URL */
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** If true, save as draft */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON as string from FilePicker */
  filepickerBlob?: InputMaybe<Scalars['String']['input']>;
  /** ID of the feed post (story answer) to update */
  id: Scalars['ID']['input'];
  /** Internal name of the post */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Org official to post as */
  postedByOfficialId?: InputMaybe<Scalars['ID']['input']>;
  /** Date to publish post at */
  publishAt?: InputMaybe<Scalars['Double']['input']>;
};

/** Autogenerated input type of UpdateUserContactInfoMutation */
export type UpdateUserContactInfoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserContactInfoMutation. */
export type UpdateUserContactInfoMutationPayload = {
  __typename?: 'UpdateUserContactInfoMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateUserNotificationSettingsMutation */
export type UpdateUserNotificationSettingsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  receiveChatEmails?: InputMaybe<YesNoEnum>;
  receiveGoingEmails?: InputMaybe<YesNoEnum>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserNotificationSettingsMutation. */
export type UpdateUserNotificationSettingsMutationPayload = {
  __typename?: 'UpdateUserNotificationSettingsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** Autogenerated input type of UpdateUserProfileAnswerMutation */
export type UpdateUserProfileAnswerMutationInput = {
  answer: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  profileAnswerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserProfileAnswerMutation. */
export type UpdateUserProfileAnswerMutationPayload = {
  __typename?: 'UpdateUserProfileAnswerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
  profileAnswer?: Maybe<ProfileAnswer>;
};

/** Autogenerated input type of UpdateUserProfileMutation */
export type UpdateUserProfileMutationInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  interestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastName: Scalars['String']['input'];
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  majorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  profilePhoto?: InputMaybe<Scalars['Upload']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserProfileMutation. */
export type UpdateUserProfileMutationPayload = {
  __typename?: 'UpdateUserProfileMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RecoverableError>>;
};

/** A user object */
export type User = ChatBaseUserInterface & Node & {
  __typename?: 'User';
  actions?: Maybe<RiseUserActionConnection>;
  bio?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Does not work for all user names */
  firstName: Scalars['String']['output'];
  hasAssignedStudents: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Interests associated with this student */
  interests?: Maybe<InterestConnection>;
  isDefaultCounselor: Scalars['Boolean']['output'];
  isSuperCounselor: Scalars['Boolean']['output'];
  lastActiveAt?: Maybe<Scalars['Double']['output']>;
  /** @deprecated Does not work for all user names */
  lastName?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<LocationCity>;
  /** Majors associated with this student */
  majors?: Maybe<MajorConnection>;
  name: Scalars['String']['output'];
  officialOrganization?: Maybe<Organization>;
  officialOrganizations?: Maybe<OrganizationConnection>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Profile answers associated with the user */
  profileAnswers?: Maybe<ProfileAnswerConnection>;
  /** The students profile photo */
  profilePhoto?: Maybe<Image>;
  receiveChatEmails: Scalars['Boolean']['output'];
  receiveGoingEmails: Scalars['Boolean']['output'];
  rise?: Maybe<RiseUserData>;
  /** What role does this user have? */
  role: UserRoleEnum;
  /** Social media handles for this user. */
  socials?: Maybe<SocialMediaHandleConnection>;
  uuid: Scalars['String']['output'];
};


/** A user object */
export type UserActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  filter?: InputMaybe<RiseUserActionFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


/** A user object */
export type UserHasAssignedStudentsArgs = {
  organizationId: Scalars['ID']['input'];
};


/** A user object */
export type UserInterestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user object */
export type UserIsDefaultCounselorArgs = {
  organizationId: Scalars['ID']['input'];
};


/** A user object */
export type UserIsSuperCounselorArgs = {
  organizationId: Scalars['ID']['input'];
};


/** A user object */
export type UserMajorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user object */
export type UserOfficialOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<OrganizationOrderingInput>;
};


/** A user object */
export type UserProfileAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: ProfileAnswerFilterEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering: ProfileAnswerOrderingInput;
};


/** A user object */
export type UserSocialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** Specifies user attributes of inclusion */
export enum UserInclusionAttributeEnum {
  /** Users that have posted to the feed */
  HasPostedToFeed = 'HAS_POSTED_TO_FEED'
}

/** Specifies user attributes of omission */
export enum UserOmissionAttributeEnum {
  /** User that is an employee */
  Employee = 'EMPLOYEE',
  /** User that is the featured student official */
  FeaturedStudentOfficial = 'FEATURED_STUDENT_OFFICIAL',
  /** User that is the permanent organization official */
  PermanentOrganizationOfficial = 'PERMANENT_ORGANIZATION_OFFICIAL'
}

/** An order by which a user connection should be ordered */
export type UserOrderingInput = {
  /** The direction in which to order */
  direction: SortDirectionEnum;
  /** The field by which to order */
  field: UserSortableFieldEnum;
};

/** Possible user roles */
export enum UserRoleEnum {
  /** Counselor */
  Counselor = 'COUNSELOR',
  /** Influencer */
  Influencer = 'INFLUENCER'
}

/** The fields by which users may be sorted */
export enum UserSortableFieldEnum {
  /** Sort by when user was last active */
  LastActiveAt = 'LAST_ACTIVE_AT',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by role */
  Role = 'ROLE'
}

export type Video = Node & {
  __typename?: 'Video';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Yes or No */
export enum YesNoEnum {
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

export type BanFromOrgMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type BanFromOrgMutation = { __typename?: 'Mutation', createBannedFromOrg?: { __typename?: 'CreateBannedFromOrgMutationPayload', clientMutationId?: string | null, errors?: Array<{ __typename?: 'RecoverableError', message?: string | null, title?: string | null }> | null } | null };

export type CreateBulkMessageMutationVariables = Exact<{
  createdById: Scalars['ID']['input'];
  draft: Scalars['Boolean']['input'];
  filters: BulkMessageFilterInput;
  messageParts?: InputMaybe<Array<MessagePartInput> | MessagePartInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sendOption?: InputMaybe<BulkMessageSendOptionInput>;
  sender?: InputMaybe<BulkMessageSenderInput>;
}>;


export type CreateBulkMessageMutation = { __typename?: 'Mutation', createBulkMessageMutation?: { __typename?: 'CreateBulkMessageMutationPayload', bulkMessage?: { __typename?: 'BulkMessage', id: string, draft?: boolean | null, audienceReach: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', cursor: string, node?: { __typename?: 'Student', id: string, uuid: string, firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type CreateDataManagementFileMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type CreateDataManagementFileMutation = { __typename?: 'Mutation', createDataManagementFileMutation?: { __typename?: 'CreateDataManagementFileMutationPayload', dataManagementFile?: { __typename?: 'DataManagementFile', id: string, name?: string | null, url?: string | null, createdAt?: any | null } | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type CreateInvitationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  role: DashInviteRoleEnum;
}>;


export type CreateInvitationMutation = { __typename?: 'Mutation', createDashInviteMutation?: { __typename?: 'CreateDashInviteMutationPayload', messages?: Array<{ __typename?: 'InformationalMessage', title?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type CreateProfileAnswerMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  profileQuestionId: Scalars['ID']['input'];
  answer: Scalars['String']['input'];
}>;


export type CreateProfileAnswerMutation = { __typename?: 'Mutation', createUserProfileAnswerMutation?: { __typename?: 'CreateUserProfileAnswerMutationPayload', clientMutationId?: string | null, profileAnswer?: { __typename?: 'ProfileAnswer', id: string, text?: string | null, question: { __typename?: 'ProfileQuestion', id: string, text?: string | null } } | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type DestroyBulkMessageMutationVariables = Exact<{
  bulkMessageId: Scalars['ID']['input'];
}>;


export type DestroyBulkMessageMutation = { __typename?: 'Mutation', destroyBulkMessageMutation?: { __typename?: 'DestroyBulkMessageMutationPayload', success?: boolean | null, errors: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> } | null };

export type DestroyFeedPostMutationVariables = Exact<{
  input: DestroyFeedPostMutationInput;
}>;


export type DestroyFeedPostMutation = { __typename?: 'Mutation', destroyFeedPostMutation?: { __typename?: 'DestroyFeedPostMutationPayload', clientMutationId?: string | null, success?: boolean | null, errors: Array<{ __typename?: 'RecoverableError', message?: string | null, title?: string | null }> } | null };

export type DestroyInviteMutationVariables = Exact<{
  dashInviteId: Scalars['ID']['input'];
}>;


export type DestroyInviteMutation = { __typename?: 'Mutation', destroyDashInviteMutation?: { __typename?: 'DestroyDashInviteMutationPayload', errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type DestroyLiveEventMutationVariables = Exact<{
  liveEventId: Scalars['ID']['input'];
}>;


export type DestroyLiveEventMutation = { __typename?: 'Mutation', destroyLiveEventMutation?: { __typename?: 'DestroyLiveEventMutationPayload', success?: boolean | null, errors: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> } | null };

export type DestroyProfileAnswerMutationVariables = Exact<{
  input: DestroyProfileAnswerMutationInput;
}>;


export type DestroyProfileAnswerMutation = { __typename?: 'Mutation', destroyProfileAnswerMutation?: { __typename?: 'DestroyProfileAnswerMutationPayload', clientMutationId?: string | null, success?: boolean | null, errors: Array<{ __typename?: 'RecoverableError', message?: string | null, title?: string | null }> } | null };

export type RemoveOfficialFromOrganizationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type RemoveOfficialFromOrganizationMutation = { __typename?: 'Mutation', removeOfficialFromOrganizationMutation?: { __typename?: 'RemoveOfficialFromOrganizationMutationPayload', errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type ReplaceUserSocialsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  socials: Array<SocialMediaHandleInput> | SocialMediaHandleInput;
}>;


export type ReplaceUserSocialsMutation = { __typename?: 'Mutation', replaceUserSocialsMutation?: { __typename?: 'ReplaceUserSocialsMutationPayload', clientMutationId?: string | null, socials?: Array<{ __typename?: 'SocialMediaHandle', id: string, handle: string, platform?: { __typename?: 'SocialMediaHandlePlatform', id: string, name: string, baseUrl?: string | null, icon?: { __typename?: 'Image', url?: string | null } | null } | null }> | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type ReportChatMessageMutationVariables = Exact<{
  reportedUserId: Scalars['ID']['input'];
  chatMessageId: Scalars['String']['input'];
  reason: ReportedContentReasonEnum;
  image: Scalars['Upload']['input'];
}>;


export type ReportChatMessageMutation = { __typename?: 'Mutation', createReportedContentMutation?: { __typename?: 'CreateReportedContentMutationPayload', clientMutationId?: string | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type ReportUserMutationVariables = Exact<{
  reportedUserId: Scalars['ID']['input'];
  reason: ReportedContentReasonEnum;
  image: Scalars['Upload']['input'];
}>;


export type ReportUserMutation = { __typename?: 'Mutation', createReportedContentMutation?: { __typename?: 'CreateReportedContentMutationPayload', clientMutationId?: string | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type ResendInviteMutationVariables = Exact<{
  dashInviteId: Scalars['ID']['input'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendDashInviteMutation?: { __typename?: 'ResendDashInviteMutationPayload', errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type StopBulkMessageMutationVariables = Exact<{
  bulkMessageId: Scalars['ID']['input'];
}>;


export type StopBulkMessageMutation = { __typename?: 'Mutation', stopBulkMessageMutation?: { __typename?: 'StopBulkMessageMutationPayload', success: boolean, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type UpdateBulkMessageMutationVariables = Exact<{
  bulkMessageId: Scalars['ID']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<BulkMessageFilterInput>;
  messageParts?: InputMaybe<Array<MessagePartInput> | MessagePartInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendOption?: InputMaybe<BulkMessageSendOptionInput>;
  sender?: InputMaybe<BulkMessageSenderInput>;
}>;


export type UpdateBulkMessageMutation = { __typename?: 'Mutation', updateBulkMessageMutation?: { __typename?: 'UpdateBulkMessageMutationPayload', bulkMessage?: { __typename?: 'BulkMessage', id: string, draft?: boolean | null, audienceReach: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', cursor: string, node?: { __typename?: 'Student', id: string, uuid: string, firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type UpdateContactInfoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type UpdateContactInfoMutation = { __typename?: 'Mutation', updateUserContactInfoMutation?: { __typename?: 'UpdateUserContactInfoMutationPayload', clientMutationId?: string | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type UpdateProfileAnswerMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  profileAnswerId: Scalars['ID']['input'];
  answer: Scalars['String']['input'];
}>;


export type UpdateProfileAnswerMutation = { __typename?: 'Mutation', updateUserProfileAnswerMutation?: { __typename?: 'UpdateUserProfileAnswerMutationPayload', clientMutationId?: string | null, profileAnswer?: { __typename?: 'ProfileAnswer', id: string, text?: string | null, question: { __typename?: 'ProfileQuestion', id: string, text?: string | null } } | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  bio?: InputMaybe<Scalars['String']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  interestIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  majorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  profilePhoto?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateUserProfileMutation?: { __typename?: 'UpdateUserProfileMutationPayload', clientMutationId?: string | null, errors?: Array<{ __typename?: 'RecoverableError', title?: string | null, message?: string | null }> | null } | null };

export type BulkMessageQueryVariables = Exact<{
  bulkMessageId: Scalars['ID']['input'];
}>;


export type BulkMessageQuery = { __typename?: 'Query', node?: { __typename: 'BulkMessage', id: string, name: string, createdAt: any, campaignType: BulkMessageCampaignTypeEnum, draft?: boolean | null, senderType: BulkMessageSenderTypeEnum, startSendingAt?: any | null, stopSendingAt?: any | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, uuid: string } | null, filters: { __typename?: 'BulkMessageFilter', assignedCounselorIds?: Array<string> | null, studentTypes?: Array<StudentTypeEnum> | null, funnelStates?: Array<FunnelStateEnum> | null, locations?: Array<BulkMessageLocationEnum> | null, interestIds?: Array<string> | null, majorIds?: Array<string> | null, studentSource?: Array<BulkMessageStudentSourceEnum> | null, commitIndexes?: Array<PredictionIndexEnum> | null, userIds?: Array<string> | null, firstTimeMessageRecipients?: Array<MessagingYesNoEnum> | null, startTerms?: Array<{ __typename?: 'BulkMessageStartTerm', semester?: EntryTermEnum | null, year?: number | null }> | null }, messageParts?: { __typename?: 'MessagePartConnection', edges?: Array<{ __typename?: 'MessagePartEdge', node?: { __typename?: 'MessagePart', id: string, body: { __typename?: 'MessagePartAttachment', url: string, type: MessagePartAttachmentEnum } | { __typename?: 'MessagePartText', text: string } } | null } | null> | null } | null, sentTo: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', url?: string | null } | null } | null } | null> | null }, sentFrom?: { __typename?: 'User', id: string, firstName: string, email?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization' } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type ProposeBulkMessageQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  imageSize?: InputMaybe<Scalars['Int']['input']>;
  filters: BulkMessageFilterInput;
}>;


export type ProposeBulkMessageQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename: 'Organization', id: string, bulkMessageProposal: { __typename?: 'BulkMessageCsvProposal' } | { __typename?: 'BulkMessageFilterProposal', students: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', id: string, uuid: string, firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null } } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type ProposeBulkMessageCsvQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  imageSize?: InputMaybe<Scalars['Int']['input']>;
  csvFile: Scalars['Upload']['input'];
}>;


export type ProposeBulkMessageCsvQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename: 'Organization', id: string, bulkMessageProposal: { __typename?: 'BulkMessageCsvProposal', missingStudentIds: Array<number>, students: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', id: string, uuid: string, firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null } } | { __typename?: 'BulkMessageFilterProposal' } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type BulkMessages_WithBulkMessageOrderingQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  cohortYear?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  after: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  orderingDirection: SortDirectionEnum;
}>;


export type BulkMessages_WithBulkMessageOrderingQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename: 'Organization', id: string, name: string, studentList: { __typename?: 'StudentConnection', edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', id: string, uuid: string, imageUrl?: { __typename?: 'Image', url?: string | null } | null, interests?: { __typename?: 'InterestConnection', edges?: Array<{ __typename?: 'InterestEdge', node?: { __typename?: 'Interest', id: string, name: string } | null } | null> | null } | null, majors?: { __typename?: 'MajorConnection', edges?: Array<{ __typename?: 'MajorEdge', node?: { __typename?: 'Major', id: string, name: string } | null } | null> | null } | null, studentOrganizationStatus?: { __typename?: 'StudentOrganizationStatus', firstName?: string | null, lastName?: string | null, location?: string | null, lastActiveAt?: any | null, cohortYear?: number | null, commitPercentile?: any | null, highSchool?: string | null, funnelState?: FunnelStateEnum | null, email?: string | null, studentType?: StudentTypeEnum | null } | null } | null } | null> | null } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type OrganizationBulkMessagesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sendStatus: Array<BulkMessageSendStatusEnum> | BulkMessageSendStatusEnum;
  campaignType: Array<BulkMessageCampaignTypeEnum> | BulkMessageCampaignTypeEnum;
  ordering: Array<BulkMessageOrderingInput> | BulkMessageOrderingInput;
  sentFrom?: InputMaybe<Array<BulkMessageSentFromFilterInput> | BulkMessageSentFromFilterInput>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OrganizationBulkMessagesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename: 'Organization', id: string, bulkMessages: { __typename?: 'BulkMessageConnection', totalCount: number, edges?: Array<{ __typename?: 'BulkMessageEdge', cursor: string, node?: { __typename?: 'BulkMessage', id: string, name: string, createdAt: any, campaignType: BulkMessageCampaignTypeEnum, senderType: BulkMessageSenderTypeEnum, startSendingAt?: any | null, stopSendingAt?: any | null, audienceReach: { __typename?: 'StudentConnection', totalCount: number, nodes?: Array<{ __typename?: 'Student', firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', url?: string | null } | null } | null> | null }, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, uuid: string } | null, sentTo: { __typename?: 'StudentConnection', totalCount: number, nodes?: Array<{ __typename?: 'Student', firstName?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', url?: string | null } | null } | null> | null }, sentFrom?: { __typename?: 'User', firstName: string, email?: string | null, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type OrganizationChatChannelsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  hasBeenUsedForLiveEvent?: InputMaybe<Scalars['Boolean']['input']>;
  ordering: Array<ChatChannelOrderingInput> | ChatChannelOrderingInput;
}>;


export type OrganizationChatChannelsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename: 'Organization', id: string, chatChannels?: { __typename?: 'ChatChannelConnection', totalCount: number, edges?: Array<{ __typename?: 'ChatChannelEdge', cursor: string, node?: { __typename?: 'ChatChannel', id: string, roomName: string, displayName: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type CommitIndexStudentsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  commitIndex: PredictionIndexEnum;
  sortField: StudentListCommitIndexOrderingOneOfInput;
  funnelStatesFilter?: InputMaybe<Array<FunnelStateEnum> | FunnelStateEnum>;
  previousCommitIndexFilter?: InputMaybe<Array<PredictionIndexEnum> | PredictionIndexEnum>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommitIndexStudentsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, studentList: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', id: string, name?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null, studentOrganizationStatus?: { __typename?: 'StudentOrganizationStatus', commitIndex?: PredictionIndexEnum | null, previousCommitIndex?: PredictionIndexEnum | null, commitScore?: any | null, commitIndexChangedToLowOn?: any | null, commitIndexChangedToMediumOn?: any | null, commitIndexChangedToHighOn?: any | null, funnelState?: FunnelStateEnum | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type CommitIndexSummaryQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  cohortYear: Scalars['Int']['input'];
}>;


export type CommitIndexSummaryQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, commitIndexSummary: { __typename?: 'PredictionIndexSummary', low?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, medium?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, high?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type CommitScoreTimeSeriesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type CommitScoreTimeSeriesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string, commitScoreTimeSeries?: Array<{ __typename?: 'PredictiveIndexTimeSeriesDataPoint', date: any, value?: any | null, index?: PredictionIndexEnum | null }> | null } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type CommunityGrowthQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  cohortYear: Scalars['Int']['input'];
  inCommunity: YesNoEnum;
}>;


export type CommunityGrowthQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, studentListTimeSeries?: Array<{ __typename?: 'TimeSeriesDataPoint', date: any, value: any }> | null } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type ContextMetricsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  context: OrganizationMetricsContextEnum;
}>;


export type ContextMetricsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, metrics?: Array<{ __typename?: 'OrganizationMetric', name?: string | null, value?: any | null, previousCycleValue?: any | null }> | null } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type CurrentCohortYearQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCohortYearQuery = { __typename?: 'Query', currentCohortYear: number };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, uuid: string, name: string, firstName: string, lastName?: string | null, email?: string | null, role: UserRoleEnum, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null, officialOrganization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type CurrentUserOrgsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentUserOrgsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, officialOrganizations?: { __typename?: 'OrganizationConnection', totalCount: number, edges?: Array<{ __typename?: 'OrganizationEdge', node?: { __typename?: 'Organization', id: string, uuid: string, name: string, seatsAvailable: number, logo?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type CurrentUserOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserOrgQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, officialOrganization?: { __typename?: 'Organization', id: string, uuid: string, name: string, seatsAvailable: number, logo?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } };

export type CurrentUserPermissionsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CurrentUserPermissionsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, uuid: string, isDefaultCounselor: boolean, isSuperCounselor: boolean } };

export type DataManagementFilesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Array<DataManagementFileOrderingInput> | DataManagementFileOrderingInput>;
}>;


export type DataManagementFilesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, dataManagementFiles?: { __typename?: 'DataManagementFileConnection', totalCount: number, edges?: Array<{ __typename?: 'DataManagementFileEdge', cursor: string, node?: { __typename?: 'DataManagementFile', id: string, name?: string | null, url?: string | null, createdAt?: any | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type FeaturedStudentsSpotlightQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  imageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeaturedStudentsSpotlightQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, featuredStudentSpotlight?: Array<{ __typename?: 'FeaturedStudentSpotlight', reason?: string | null, student?: { __typename?: 'Student', id: string, uuid: string, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null, studentOrganizationStatus?: { __typename?: 'StudentOrganizationStatus', highSchool?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, location?: string | null } | null, interests?: { __typename?: 'InterestConnection', edges?: Array<{ __typename?: 'InterestEdge', node?: { __typename?: 'Interest', id: string, name: string } | null } | null> | null } | null, majors?: { __typename?: 'MajorConnection', edges?: Array<{ __typename?: 'MajorEdge', node?: { __typename?: 'Major', id: string, name: string } | null } | null> | null } | null, socials?: { __typename?: 'SocialMediaHandleConnection', edges?: Array<{ __typename?: 'SocialMediaHandleEdge', node?: { __typename?: 'SocialMediaHandle', platform?: { __typename?: 'SocialMediaHandlePlatform', id: string, name: string } | null } | null } | null> | null } | null } | null }> | null } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type FeedPostQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeedPostQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost', id: string, name: string, caption?: string | null, ctaText?: string | null, ctaUrl?: string | null, publishDate: any, image?: { __typename?: 'Image', id: string, url?: string | null } | null, video?: { __typename?: 'Video', id: string, url?: string | null } | null, postedBy: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null }, organization?: { __typename?: 'Organization', id: string, name: string } | null } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization' } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type OrganizationFeedPostsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<FeedPostStatusEnum> | FeedPostStatusEnum>;
  ctaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  postedBy?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  ordering?: InputMaybe<Array<FeedPostOrderingInput> | FeedPostOrderingInput>;
}>;


export type OrganizationFeedPostsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, feedPosts: { __typename?: 'FeedPostConnection', totalCount: number, edges?: Array<{ __typename?: 'FeedPostEdge', cursor: string, node?: { __typename?: 'FeedPost', id: string, name: string, ctaUrl?: string | null, publishDate: any, views?: number | null, ctaStudent?: { __typename?: 'Student', id: string } | null, postedBy: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type FunFactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FunFactsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization' } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student', id: string, profileAnswers?: { __typename?: 'ProfileAnswerConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ __typename?: 'ProfileAnswerEdge', cursor: string, node?: { __typename?: 'ProfileAnswer', text?: string | null, question: { __typename?: 'ProfileQuestion', text?: string | null } } | null } | null> | null } | null } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type FunnelChartDataQueryVariables = Exact<{
  date: Scalars['Date']['input'];
  orgId: Scalars['ID']['input'];
  filters: StudentListFilterInput;
}>;


export type FunnelChartDataQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, funnelChartData?: { __typename?: 'FunnelChartData', inCommunity: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }>, notInCommunity: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> } | null } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type InterestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InterestsQuery = { __typename?: 'Query', interests: { __typename?: 'InterestConnection', totalCount: number, edges?: Array<{ __typename?: 'InterestEdge', cursor: string, node?: { __typename?: 'Interest', name: string, id: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type InviteQueryVariables = Exact<{
  dashInviteId: Scalars['ID']['input'];
}>;


export type InviteQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename: 'DashInvite', id: string, email: string, firstName: string, lastName?: string | null, invitedAt: any, phoneNumber: string, role: DashInviteRoleEnum } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization' } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type InvitesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  roles: Array<DashInviteRoleEnum> | DashInviteRoleEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ordering: Array<DashInviteOrderingInput> | DashInviteOrderingInput;
}>;


export type InvitesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, dashInvites: { __typename?: 'DashInviteConnection', totalCount: number, edges?: Array<{ __typename?: 'DashInviteEdge', cursor: string, node?: { __typename?: 'DashInvite', id: string, email: string, firstName: string, invitedAt: any, lastName?: string | null, phoneNumber: string, role: DashInviteRoleEnum } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type LiveEventStatsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  filters?: InputMaybe<StudentListFilterInput>;
}>;


export type LiveEventStatsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string, statistics?: { __typename?: 'LiveEventStatistics', studentsWhoMessaged?: number | null, totalMessages?: number | null, totalChannelOpens?: number | null, totalParticipants?: number | null } | null } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type LiveEventDetailsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type LiveEventDetailsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', audience: LiveEventAudienceEnum, eventType: LiveEventTypeEnum, gameType?: string | null, gameVariation?: string | null, name: string, startsAt: any, id: string, chatChannel: { __typename?: 'ChatChannel', displayName: string } } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type LiveEventParticipantCountsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  filters?: InputMaybe<StudentListFilterInput>;
}>;


export type LiveEventParticipantCountsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string, participantsByFunnelState?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type LocationsQueryVariables = Exact<{
  filter: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocationsQuery = { __typename?: 'Query', locationCities: { __typename?: 'LocationCityConnection', totalCount: number, edges?: Array<{ __typename?: 'LocationCityEdge', cursor: string, node?: { __typename?: 'LocationCity', displayString: string, id: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type MajorQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MajorQuery = { __typename?: 'Query', majors: { __typename?: 'MajorConnection', totalCount: number, edges?: Array<{ __typename?: 'MajorEdge', cursor: string, node?: { __typename?: 'Major', name: string, id: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, uuid: string, firstName: string, lastName?: string | null, bio?: string | null, email?: string | null, phoneNumber?: string | null, locationCity?: { __typename?: 'LocationCity', id: string, displayString: string } | null, interests?: { __typename?: 'InterestConnection', nodes?: Array<{ __typename?: 'Interest', id: string, name: string } | null> | null } | null, majors?: { __typename?: 'MajorConnection', nodes?: Array<{ __typename?: 'Major', id: string, name: string } | null> | null } | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null, officialOrganization?: { __typename?: 'Organization', ssoEnabled: boolean } | null, socials?: { __typename?: 'SocialMediaHandleConnection', nodes?: Array<{ __typename?: 'SocialMediaHandle', id: string, handle: string, platform?: { __typename?: 'SocialMediaHandlePlatform', id: string, name: string, baseUrl?: string | null, icon?: { __typename?: 'Image', url?: string | null } | null } | null } | null> | null } | null } };

export type OrganizationDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationDetailsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, uuid: string, name: string, seatsAvailable: number, logo?: { __typename?: 'Image', id: string, url?: string | null } | null } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type OrganizationLiveEventsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  audience?: InputMaybe<Array<LiveEventAudienceEnum> | LiveEventAudienceEnum>;
  eventType?: InputMaybe<Array<LiveEventTypeEnum> | LiveEventTypeEnum>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  ordering: Array<LiveEventOrderingInput> | LiveEventOrderingInput;
  status: Array<LiveEventStatusEnum> | LiveEventStatusEnum;
  chatChannel?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OrganizationLiveEventsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename: 'Organization', id: string, liveEvents: { __typename?: 'LiveEventConnection', totalCount: number, edges?: Array<{ __typename?: 'LiveEventEdge', cursor: string, node?: { __typename?: 'LiveEvent', id: string, name: string, eventType: LiveEventTypeEnum, audience: LiveEventAudienceEnum, startsAt: any, endsAt: any, chatChannel: { __typename?: 'ChatChannel', id: string, name: string, displayName: string, roomName: string }, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, uuid: string, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null, statistics?: { __typename?: 'LiveEventStatistics', totalMessages?: number | null, totalParticipants?: number | null, studentsWhoMessaged?: number | null, totalChannelOpens?: number | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type OrgFeatureFlagsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrgFeatureFlagsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, permissions: { __typename?: 'OrganizationPermission', flags?: Array<PartnerFeatureEnum> | null, partnershipLevel?: OrganizationPartnershipLevelEnum | null } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type OrgTimeZoneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrgTimeZoneQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, timeZone: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type PredictiveIndexStudentsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  argument: StudentListArgumentInput;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PredictiveIndexStudentsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, studentList: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', id: string, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null, studentOrganizationStatus?: { __typename?: 'StudentOrganizationStatus', name?: string | null, commitIndex?: PredictionIndexEnum | null, previousCommitIndex?: PredictionIndexEnum | null, commitScore?: any | null, commitIndexChangedToLowOn?: any | null, commitIndexChangedToMediumOn?: any | null, commitIndexChangedToHighOn?: any | null, funnelState?: FunnelStateEnum | null, inCommunity?: YesNoEnum | null, rise?: { __typename?: 'RiseStudentOrganizationStatusData', applyIndex?: RisePredictiveIndexEnum | null, previousApplyIndex?: RisePredictiveIndexEnum | null, applyScore?: any | null, applyIndexChangedToLowOn?: any | null, applyIndexChangedToMediumLowOn?: any | null, applyIndexChangedToMediumOn?: any | null, applyIndexChangedToMediumHighOn?: any | null, applyIndexChangedToHighOn?: any | null, commitIndex?: RisePredictiveIndexEnum | null, previousCommitIndex?: RisePredictiveIndexEnum | null, commitScore?: any | null, commitIndexChangedToLowOn?: any | null, commitIndexChangedToMediumLowOn?: any | null, commitIndexChangedToMediumOn?: any | null, commitIndexChangedToMediumHighOn?: any | null, commitIndexChangedToHighOn?: any | null, meltIndex?: RisePredictiveIndexEnum | null, previousMeltIndex?: RisePredictiveIndexEnum | null, meltScore?: any | null, meltIndexChangedToLowOn?: any | null, meltIndexChangedToMediumLowOn?: any | null, meltIndexChangedToMediumOn?: any | null, meltIndexChangedToMediumHighOn?: any | null, meltIndexChangedToHighOn?: any | null, yieldIndex?: RisePredictiveIndexEnum | null, previousYieldIndex?: RisePredictiveIndexEnum | null, yieldScore?: any | null, yieldIndexChangedToLowOn?: any | null, yieldIndexChangedToMediumLowOn?: any | null, yieldIndexChangedToMediumOn?: any | null, yieldIndexChangedToMediumHighOn?: any | null, yieldIndexChangedToHighOn?: any | null, retainIndex?: RisePredictiveIndexEnum | null, previousRetainIndex?: RisePredictiveIndexEnum | null, retainScore?: any | null, retainIndexChangedToLowOn?: any | null, retainIndexChangedToMediumLowOn?: any | null, retainIndexChangedToMediumOn?: any | null, retainIndexChangedToMediumHighOn?: any | null, retainIndexChangedToHighOn?: any | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type ProfileAnswersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ProfileAnswersQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization' } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User', id: string, profileAnswers?: { __typename?: 'ProfileAnswerConnection', nodes?: Array<{ __typename?: 'ProfileAnswer', id: string, text?: string | null, question: { __typename?: 'ProfileQuestion', id: string, text?: string | null } } | null> | null } | null } | { __typename?: 'Video' } | null };

export type ProfileQuestionsQueryVariables = Exact<{
  notAnsweredByUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProfileQuestionsQuery = { __typename?: 'Query', profileQuestions: { __typename?: 'ProfileQuestionConnection', nodes?: Array<{ __typename?: 'ProfileQuestion', id: string, text?: string | null } | null> | null } };

export type RiseApplyIndexSummaryQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
}>;


export type RiseApplyIndexSummaryQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, rise?: { __typename?: 'RiseOrganization', applyIndexSummary?: { __typename?: 'RisePredictiveIndexSummary', low?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumLow?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, medium?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumHigh?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, high?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null } | null } | null } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseApplyScoreTimeSeriesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RiseApplyScoreTimeSeriesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename: 'Student', id: string, rise?: { __typename?: 'RiseStudentData', applyScoreTimeSeries?: Array<{ __typename?: 'RisePredictiveIndexTimeSeriesDataPoint', date: any, value: any, index?: RisePredictiveIndexEnum | null }> | null } | null } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseCommitIndexSummaryQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
}>;


export type RiseCommitIndexSummaryQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, rise?: { __typename?: 'RiseOrganization', commitIndexSummary?: { __typename?: 'RisePredictiveIndexSummary', low?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumLow?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, medium?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumHigh?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, high?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null } | null } | null } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseCommitScoreTimeSeriesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RiseCommitScoreTimeSeriesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename: 'Student', id: string, rise?: { __typename?: 'RiseStudentData', commitScoreTimeSeries?: Array<{ __typename?: 'RisePredictiveIndexTimeSeriesDataPoint', date: any, value: any, index?: RisePredictiveIndexEnum | null }> | null } | null } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseMeltIndexSummaryQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
}>;


export type RiseMeltIndexSummaryQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, rise?: { __typename?: 'RiseOrganization', meltIndexSummary?: { __typename?: 'RisePredictiveIndexSummary', low?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumLow?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, medium?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumHigh?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, high?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null } | null } | null } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseMeltScoreTimeSeriesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RiseMeltScoreTimeSeriesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename: 'Student', id: string, rise?: { __typename?: 'RiseStudentData', meltScoreTimeSeries?: Array<{ __typename?: 'RisePredictiveIndexTimeSeriesDataPoint', date: any, value: any, index?: RisePredictiveIndexEnum | null }> | null } | null } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseYieldIndexSummaryQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  cohortYear: Scalars['Int']['input'];
  inCommunity?: InputMaybe<YesNoEnum>;
}>;


export type RiseYieldIndexSummaryQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, rise?: { __typename?: 'RiseOrganization', yieldIndexSummary?: { __typename?: 'RisePredictiveIndexSummary', low?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumLow?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, medium?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, mediumHigh?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null, high?: Array<{ __typename?: 'FunnelStateDataPoint', state: FunnelStateEnum, value: number }> | null } | null } | null } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type RiseYieldScoreTimeSeriesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RiseYieldScoreTimeSeriesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename: 'Student', id: string, rise?: { __typename?: 'RiseStudentData', yieldScoreTimeSeries?: Array<{ __typename?: 'RisePredictiveIndexTimeSeriesDataPoint', date: any, value: any, index?: RisePredictiveIndexEnum | null }> | null } | null } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };

export type SocialMediaPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialMediaPlatformsQuery = { __typename?: 'Query', socialMediaPlatforms: { __typename?: 'SocialMediaHandlePlatformConnection', nodes?: Array<{ __typename?: 'SocialMediaHandlePlatform', id: string, name: string, baseUrl?: string | null, icon?: { __typename?: 'Image', url?: string | null } | null } | null> | null } };

export type StudentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  profilePhotoSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StudentQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization' } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student', id: string, uuid: string, majors?: { __typename?: 'MajorConnection', edges?: Array<{ __typename?: 'MajorEdge', node?: { __typename?: 'Major', name: string, id: string } | null } | null> | null } | null, interests?: { __typename?: 'InterestConnection', edges?: Array<{ __typename?: 'InterestEdge', node?: { __typename?: 'Interest', name: string, id: string } | null } | null> | null } | null, socials?: { __typename?: 'SocialMediaHandleConnection', edges?: Array<{ __typename?: 'SocialMediaHandleEdge', node?: { __typename?: 'SocialMediaHandle', handle: string, platform?: { __typename?: 'SocialMediaHandlePlatform', name: string, baseUrl?: string | null, icon?: { __typename?: 'Image', url?: string | null } | null } | null } | null } | null> | null } | null, studentOrganizationStatus?: { __typename?: 'StudentOrganizationStatus', bio?: string | null, cohortYear?: number | null, commitIndex?: PredictionIndexEnum | null, commitIndexChangedOn?: any | null, commitPercentile?: any | null, commitScore?: any | null, crmId?: string | null, crmUrl?: string | null, email?: string | null, fafsaCompletionStatus?: FafsaCompletionStatusEnum | null, name?: string | null, firstName?: string | null, funnelState?: FunnelStateEnum | null, goingStatus?: GoingStatusEnum | null, goingStatusChangedOn?: any | null, hasTakenRoommateQuiz?: YesNoEnum | null, highSchool?: string | null, joinType?: JoinTypeEnum | null, joinedOn?: any | null, lastActiveAt?: any | null, lastName?: string | null, liveEventsAttended?: number | null, location?: string | null, lookingForRoommate?: YesNoEnum | null, phoneNumber?: string | null, schoolsAdmittedTo?: number | null, schoolsFollowing?: number | null, studentType?: StudentTypeEnum | null, visitedCampus?: YesNoEnum | null, becameUninterestedOn?: any | null, inCommunity?: YesNoEnum | null, interested?: YesNoEnum | null, assignedCounselor?: { __typename?: 'User', id: string, uuid: string, firstName: string, lastName?: string | null, name: string, isDefaultCounselor: boolean, isSuperCounselor: boolean, role: UserRoleEnum } | null, funnelStateTransitionSummary?: Array<{ __typename?: 'FunnelStateTransitionDate', state: FunnelStateEnum, date: any }> | null, rise?: { __typename?: 'RiseStudentOrganizationStatusData', applyIndex?: RisePredictiveIndexEnum | null, applyScore?: any | null, commitIndex?: RisePredictiveIndexEnum | null, commitIndexChangedOn?: any | null, commitScore?: any | null, meltIndex?: RisePredictiveIndexEnum | null, meltScore?: any | null, yieldIndex?: RisePredictiveIndexEnum | null, yieldScore?: any | null } | null } | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type StudentListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  imageSize?: InputMaybe<Scalars['Int']['input']>;
  argument: StudentListArgumentInput;
}>;


export type StudentListQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, studentList: { __typename?: 'StudentConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'Student', id: string, uuid: string, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null, interests?: { __typename?: 'InterestConnection', edges?: Array<{ __typename?: 'InterestEdge', node?: { __typename?: 'Interest', id: string, name: string } | null } | null> | null } | null, majors?: { __typename?: 'MajorConnection', edges?: Array<{ __typename?: 'MajorEdge', node?: { __typename?: 'Major', id: string, name: string } | null } | null> | null } | null, studentOrganizationStatus?: { __typename?: 'StudentOrganizationStatus', bio?: string | null, cohortYear?: number | null, commitIndex?: PredictionIndexEnum | null, commitIndexChangedOn?: any | null, commitPercentile?: any | null, crmUrl?: string | null, lastActiveAt?: any | null, email?: string | null, firstName?: string | null, name?: string | null, funnelState?: FunnelStateEnum | null, goingStatus?: GoingStatusEnum | null, highSchool?: string | null, joinType?: JoinTypeEnum | null, messagesSent?: number | null, lastName?: string | null, location?: string | null, phoneNumber?: string | null, studentType?: StudentTypeEnum | null, assignedCounselor?: { __typename?: 'User', firstName: string, lastName?: string | null, name: string } | null, rise?: { __typename?: 'RiseStudentOrganizationStatusData', applyIndex?: RisePredictiveIndexEnum | null, commitIndex?: RisePredictiveIndexEnum | null, meltIndex?: RisePredictiveIndexEnum | null, yieldIndex?: RisePredictiveIndexEnum | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type StudentListTimeSeriesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  argument: StudentListTimeSeriesArgumentInput;
}>;


export type StudentListTimeSeriesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, studentListTimeSeries?: Array<{ __typename?: 'TimeSeriesDataPoint', date: any, value: any }> | null } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type TeammatesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  roles: Array<UserRoleEnum> | UserRoleEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  imageSize: Scalars['Int']['input'];
  ordering: Array<UserOrderingInput> | UserOrderingInput;
  omissions?: InputMaybe<Array<UserOmissionAttributeEnum> | UserOmissionAttributeEnum>;
}>;


export type TeammatesQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, users: { __typename?: 'UserConnection', totalCount: number, edges?: Array<{ __typename?: 'UserEdge', cursor: string, node?: { __typename?: 'User', id: string, uuid: string, email?: string | null, firstName: string, isDefaultCounselor: boolean, isSuperCounselor: boolean, lastName?: string | null, lastActiveAt?: any | null, name: string, phoneNumber?: string | null, role: UserRoleEnum, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type UsersByRoleQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  roles: Array<UserRoleEnum> | UserRoleEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  imageSize: Scalars['Int']['input'];
  omissions?: InputMaybe<Array<UserOmissionAttributeEnum> | UserOmissionAttributeEnum>;
}>;


export type UsersByRoleQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage' } | { __typename?: 'ChatChannel' } | { __typename?: 'ChatGamesBot' } | { __typename?: 'DashInvite' } | { __typename?: 'DataManagementFile' } | { __typename?: 'FeedPost' } | { __typename?: 'IceBreaker' } | { __typename?: 'IceBreakerGroup' } | { __typename?: 'Image' } | { __typename?: 'InsightBot' } | { __typename?: 'Interest' } | { __typename?: 'LiveEvent' } | { __typename?: 'LocationCity' } | { __typename?: 'Major' } | { __typename?: 'MessagePart' } | { __typename?: 'Organization', id: string, users: { __typename?: 'UserConnection', totalCount: number, edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, uuid: string, firstName: string, lastName?: string | null, name: string, role: UserRoleEnum, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | { __typename?: 'ProfileAnswer' } | { __typename?: 'ProfileQuestion' } | { __typename?: 'RiseActionGroup' } | { __typename?: 'RiseUserAction' } | { __typename?: 'RiseUserActionGoal' } | { __typename?: 'RiseUserActionStudentStatus' } | { __typename?: 'RiseUserActionType' } | { __typename?: 'SocialMediaHandle' } | { __typename?: 'SocialMediaHandlePlatform' } | { __typename?: 'Student' } | { __typename?: 'Surprise' } | { __typename?: 'User' } | { __typename?: 'Video' } | null };

export type OrganizationUsersWithFeedPostsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  imageSize: Scalars['Int']['input'];
}>;


export type OrganizationUsersWithFeedPostsQuery = { __typename?: 'Query', node?: { __typename?: 'BulkMessage', id: string } | { __typename?: 'ChatChannel', id: string } | { __typename?: 'ChatGamesBot', id: string } | { __typename?: 'DashInvite', id: string } | { __typename?: 'DataManagementFile', id: string } | { __typename?: 'FeedPost', id: string } | { __typename?: 'IceBreaker', id: string } | { __typename?: 'IceBreakerGroup', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'InsightBot', id: string } | { __typename?: 'Interest', id: string } | { __typename?: 'LiveEvent', id: string } | { __typename?: 'LocationCity', id: string } | { __typename?: 'Major', id: string } | { __typename?: 'MessagePart', id: string } | { __typename?: 'Organization', id: string, users: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, uuid: string, firstName: string, lastName?: string | null, profilePhoto?: { __typename?: 'Image', id: string, url?: string | null } | null } | null } | null> | null } } | { __typename?: 'ProfileAnswer', id: string } | { __typename?: 'ProfileQuestion', id: string } | { __typename?: 'RiseActionGroup', id: string } | { __typename?: 'RiseUserAction', id: string } | { __typename?: 'RiseUserActionGoal', id: string } | { __typename?: 'RiseUserActionStudentStatus', id: string } | { __typename?: 'RiseUserActionType', id: string } | { __typename?: 'SocialMediaHandle', id: string } | { __typename?: 'SocialMediaHandlePlatform', id: string } | { __typename?: 'Student', id: string } | { __typename?: 'Surprise', id: string } | { __typename?: 'User', id: string } | { __typename?: 'Video', id: string } | null };
